import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import dayjs from 'dayjs';
import download from 'downloadjs';
import router from '../router';

function normalizeName(str) {
    return (str || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase();
}

function fileToBlob(file, mimeType = 'application/octet-stream') {
    let bytes;

    if (
        file &&
        file.type === 'Buffer' &&
        Array.isArray(file.data)
    ) {
        // Buffer serialized by Express as JSON
        bytes = new Uint8Array(file.data);
    } else if (typeof file === 'string') {
        // Base64 returned by an API
        const binary = atob(file);
        bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
    } else {
        throw new Error('Unsupported file response format');
    }

    return new Blob([bytes], { type: mimeType });
}

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false, //in production set to false !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    state: {
        
        // local school
        // address_API: 'http://192.168.100.4:3030/api',

        // prod normal
        address_API: 'https://admin.proyectoperucentre.com/api',

        // prod test
        // address_API: 'https://test.proyectoperucentre.com/api',

        // local school test
        // address_API: 'http://192.168.100.4:3031/api-test',
        
        // local Mac test
        // address_API: 'http://localhost:3031/api',

        version: '14.111',

        // prod config ******************************
        // leads: [],
        paymentMethods: [],
        itemsNationality: [],
        exchangeRate: null,
        standard_rate_individual: null,
        standard_rate_group: null,
        available_services: [],
        availableOptions: [],
        availableRadioGroups: [],
        availableRadioGroupOptions: [],
        available_agencies: [],
        available_descriptions: [],
        available_images: [],
        projectCategories: [],
        projects: [],
        types: [],
        client: [],
        step: 'A',
        radioGroups: [],
        radioOptions: [],
        options: [],
        loadingApp: 0,
        loadingAppProgress: 0,
        progressBar: false,
        progressAdvance: 0,
        loadingButton: false,
        errorLogIn: null,
        statusLoggedOut: false,
        user: null,
        uid: null,
        accessTeaching: 0,
        accessAccommodation: 0,
        accessProjects: 0,
        accessTours: 0,
        accessFinancial: 0,
        accessCajaGrande: 0,
        accessClientAgencies: 0,
        accessMenu: 0,
        users: [],
        displayPets: false,
        pets_preference_set: false,
        displayFood: false,
        food_preference_set: false,
        successMessage: "",
        errorMessage: "",
        warningMessage: "",
        displaySuccessMessage: Math.random(),
        displayErrorMessage: Math.random(),
        displayWarningMessage: Math.random(),
        uploadInfos: [],
        fileName: undefined,
        messageUpload: "",
        alertVPS: 0,
        alertConnection: 0,
        timeout: 3000,
        breadcrumbs: [],
        messagesPM: [],
        contacts: [],
        organisations: [],
        organisationsContacts: [],
        projectPlacements: [],
        // accommodations: [],
        courses: [],
        activeTeachers: [],
        resultsNotSaved: false,
        language_levels: [],
        classRooms: [],
        scopeLanguage: 'allLanguages',
        scopeOnline: 'all',
        scopeResources: 'ongoing',
        scopeClassesTeachers: 'ongoing',
        scopeClassGroups: 'open',
        scopeCalendar: 'category',
        scopeServices: 'active',
        activeViewClassRooms: {view: 'day', startDate: new Date},
        activeTabTeaching: 0,
        activeTabTeachers: 0,
        scopeTypeResources: 'all',
        emailMessage: null,
        // sendEmail: null,
        scopeApplications: 'ongoing',
        directOrAgencies: 'directClients',
        selectedAgency: null,
        exchangeRates: [],
        financialLocked: null,
        reloadResourcesTourAgencies: false,
        statusClients: [
            {id: 1, name: 'completed', color: 'ppc_grey'},
            {id: 2, name: 'send thank you message', color: 'orange'},
            {id: 3, name: 'executing', color: 'ppc_darkgreen'},
            {id: 4, name: 'all set', color: 'ppc_darkgreen'},
            {id: 5, name: 'send handbook', color: 'orange'},
            {id: 6, name: 'lead', color: 'ppc_darkgreen'},
            {id: 7, name: 'payment issue', color: 'red'},
            {id: 8, name: 'cancelled', color: 'ppc_grey'},
            {id: 9, name: 'not converted', color: 'ppc_grey'},
            {id: 10, name: 'pickup info needed', color: 'orange'},
            {id: 11, name: 'send welcome email', color: 'orange'},
            {id: 12, name: 'planning', color: 'ppc_darkgreen'},
            {id: 13, name: 'waiting for client', color: 'ppc_darkgreen'},
        ],
        statusServices: [
            {id: 1, name: 'completed', color: 'ppc_grey'},
            {id: 2, name: 'executing', color: 'ppc_darkgreen'},
            {id: 3, name: 'all set', color: 'ppc_darkgreen'},
            {id: 4, name: 'resource incomplete', color: 'brown'},
            {id: 5, name: 'planning services', color: 'ppc_darkgreen'},
            {id: 6, name: 'waiting for dates', color: 'orange'},
            {id: 7, name: 'waiting for client', color: 'ppc_darkgreen'},
            {id: 8, name: 'checking availability', color: 'ppc_pink'},
            {id: 9, name: 'contact client asap', color: 'ppc_pink'},
            {id: 10, name: 'reviewing upload', color: 'ppc_pink'},
            {id: 11, name: 'waiting for passport', color: 'brown'},
            {id: 12, name: 'waiting for cv', color: 'brown'},
            {id: 13, name: 'payment needed', color: 'red'},
            {id: 14, name: 'no payment, almost starting', color: 'orange'},
            {id: 15, name: 'no payment, started', color: 'red'},
            {id: 16, name: 'cancelled', color: 'ppc_grey'},
            {id: 17, name: 'waiting for pickup info', color: 'brown'},
        ],
        statusResources: [
            {id: 1, name: 'completed', color: 'ppc_grey'},
            {id: 2, name: 'pay the provider', color: 'orange'},
            {id: 3, name: 'executing', color: 'ppc_darkgreen'},
            {id: 4, name: 'all set', color: 'ppc_darkgreen'},
            {id: 5, name: 'send info to client', color: 'orange'},
            {id: 6, name: 'waiting for confirmation provider', color: 'ppc_darkgreen'},
            {id: 7, name: 'send info to/select provider', color: 'orange'},
            {id: 8, name: 'waiting for client', color: 'ppc_darkgreen'},
            {id: 9, name: 'resource incomplete', color: 'brown'},
            {id: 10, name: 'plan classes', color: 'orange'},
            {id: 11, name: 'almost starting', color: 'blue'},
            {id: 12, name: 'did not start', color: 'red'},
            {id: 13, name: 'no security deposit', color: 'red'},
            {id: 14, name: 'return security deposit', color: 'red'},
            {id: 15, name: 'cancelled', color: 'ppc_grey'},
        ],
        showInvoice: false,
        showApplication: false,
        loadApplications: false,
        resourcePaymentFormSent: false,
        currentClient: null,
        monthCalcPaymentsAccommodation: {
            type: 'family',
            month: dayjs().format('YYYY-MM'),
        },
        selectAllTeachers: true,
        // selectAllRooms: true,
        databaseName: 'error',
        resourceLoadedChange: null,
        today: null,
        itemsPerPage: 25,
        activeDashboardTypes: JSON.parse(localStorage.getItem('dashboardTypes')) || [
            'project', 'accommodation', 'spanish', 'tour'
        ],
        // 🔧 safe defaults + merge with localStorage
        dashboardSettings: (() => {
            const defaultDashboardSettings = {
                weekOffset: 0,
                monthOffset: 0,
                tab: 0
            };

            let storedSettings = {};

            try {
                storedSettings = JSON.parse(localStorage.getItem('dashboardSettings')) || {};
            } catch (e) {
                storedSettings = {};
            }

            return {
                ...defaultDashboardSettings,
                ...storedSettings
            };
        })(),
        userPreferencesDashboard: {},
        salesSummary: null,
        salesGraph: [],
        salesHeatmap: [],
    },

    /********************************************************************************/
    /********************************************************************************/
    /********************************** GETTERS *************************************/
    /********************************************************************************/
    /********************************************************************************/

    getters: {
        // leads (state){
        //     return state.leads
        // },
        // client (state){
        //     return state.client
        // },
        radioGroups (state){
            return state.radioGroups
        },
        servicesLength (state){
            return state.services.length
        },
        statusLoggedOut (state){
            return state.statusLoggedOut
        },
        step (state) {
            return state.step
        },
        loadingApp (state) {
            return state.loadingApp
        },
        loadingAppProgress (state) {
            return state.loadingAppProgress
        },
        loadingButton (state) {
            return state.loadingButton
        },
        errorLogIn (state) {
            return state.errorLogIn
        },
        uploadInfos (state) {
            return state.uploadInfos
        },
        progressBar (state) {
            return state.progressBar
        },
        progressAdvance (state) {
            return state.progressAdvance
        },
        messageUpload (state) {
            return state.messageUpload
        },
        alertVPS (state) {
            return state.alertVPS
        },
        alertConnection (state) {
            return state.alertConnection
        },
        successMessage (state) {
            return state.successMessage
        },
        errorMessage (state) {
            return state.errorMessage
        },
        warningMessage (state) {
            return state.warningMessage
        },
        displaySuccessMessage (state) {
            return state.displaySuccessMessage
        },
        displayErrorMessage (state) {
            return state.displayErrorMessage
        },
        displayWarningMessage (state) {
            return state.displayWarningMessage
        },
        messagesPM (state) {
            return state.messagesPM
        },
        resultsNotSaved (state) {
            return state.resultsNotSaved
        },
        itemsPerPage (state) {
            return state.itemsPerPage
        },
        classRooms (state) {
            return state.classRooms
        },
        scopeLanguage (state) {
            return state.scopeLanguage
        },
        scopeOnline (state) {
            return state.scopeOnline
        },
        scopeResources (state) {
            return state.scopeResources
        },
        scopeClassesTeachers (state) {
            return state.scopeClassesTeachers
        },
        scopeClassGroups (state) {
            return state.scopeClassGroups
        },
        scopeCalendar (state) {
            return state.scopeCalendar
        },
        scopeServices (state) {
            return state.scopeServices
        },
        activeTeachers (state) {
            return state.activeTeachers
        },
        activeTabTeaching (state) {
            return state.activeTabTeaching
        },
        activeTabTeachers (state) {
            return state.activeTabTeachers
        },
        scopeTypeResources (state) {
            return state.scopeTypeResources
        },
        showInvoice (state) {
            return state.showInvoice
        },
        showApplication (state) {
            return state.showApplication
        },
        loadApplications (state) {
            return state.loadApplications
        },
        resourcePaymentFormSent (state) {
            return state.resourcePaymentFormSent
        },
        accessMenu (state) {
            return state.accessMenu
        },
        currentClient (state) {
            return state.currentClient
        },
        monthCalcPaymentsAccommodation (state) {
            return state.monthCalcPaymentsAccommodation
        },
        emailMessage (state) {
            return state.emailMessage
        },
        // sendEmail (state) {
        //     return state.sendEmail
        // },
        selectAllTeachers (state) {
            return state.selectAllTeachers
        },
        scopeApplications (state) {
            return state.scopeApplications
        },
        directOrAgencies (state) {
            return state.directOrAgencies
        },
        selectedAgency (state) {
            return state.selectedAgency
        },
        reloadResourcesTourAgencies (state) {
            return state.reloadResourcesTourAgencies
        },
        resourceLoadedChange (state) {
            return state.resourceLoadedChange
        },
        organisationsById: state =>
            new Map(state.organisations.map(o => [o.id, o])),

        organisationsByContact: state =>
            state.organisationsContacts.reduce((acc, oc) => {
            (acc[oc.contact_id] ??= []).push(oc.organisation_id);
            return acc;
            }, {}),

        organisationNamesByContact: (state, getters) => contactId =>
            (getters.organisationsByContact[contactId] || [])
            .map(id => getters.organisationsById.get(id)?.name)
            .filter(Boolean)
            .join(', '),

        contactsById: state =>
            new Map(state.contacts.map(o => [o.id, o])),

        contactNameById: (state, getters) => id => {
            const contact = getters.contactsById.get(id);
            if (!contact) return '';
            return contact.full_name || `${contact.name || ''} ${contact.surname || ''}`.trim();
        },

        contactsByOrganisation: state =>
            state.organisationsContacts.reduce((acc, oc) => {
                (acc[oc.organisation_id] ??= []).push(oc.contact_id);
                return acc;
            }, {}),
        
        contactNamesByOrganisation: (state, getters) => orgId =>
            (getters.contactsByOrganisation[orgId] || [])
            .map(id => getters.contactsById.get(id)?.full_name)
            .filter(Boolean)
            .join(', '),
        
        agenciesByOrganisationId: (state) => (organisationId) => {
            return state.available_agencies.filter(
                a => Number(a.organisation_id) === Number(organisationId)
            )
        },

        agenciesById: (state) => (agencyId) => {
            return state.available_agencies.filter(
                a => Number(a.id) === Number(agencyId)
            )
        },

        sourcesById: (state) => (sourceId) => {
            return state.itemsSources.filter(
                a => Number(a.id) === Number(sourceId)
            )
        },

        clientAgencies(state, getters) {
            return state.available_agencies
                .map(a => {
                    const salesContact = getters.contactsById.get(a.salesContact_id);
                    const organisation = getters.organisationsById.get(a.organisation_id);

                    return {
                        ...a,
                        salesContactName: salesContact
                            ? `${salesContact.name} ${salesContact.surname || ''}`.trim()
                            : null,
                        organisationName: organisation
                            ? organisation.name
                            : null,
                    };
                })
                .sort((a, b) =>
                    (a.organisationName || '').localeCompare(
                        (b.organisationName || ''),
                        undefined,
                        { sensitivity: 'base' }
                    )
                );
        },

        activeDashboardTypes: state => state.activeDashboardTypes,

        dashboardSettings: state => state.dashboardSettings,

        salesSummary: state => state.salesSummary,

        salesGraph: state => state.salesGraph,

        salesHeatmap: state => state.salesHeatmap,



    },

    /********************************************************************************/
    /********************************************************************************/
    /********************************** MUTATIONS ***********************************/
    /********************************************************************************/
    /********************************************************************************/

    mutations: {
        setAddress_API (state, payload) {
            state.address_API = payload;
        },
        breadcrumbs (state, payload) {
            console.log('Breadcrumbs: ', payload)
            state.breadcrumbs = payload;
        },
        showInvoice (state, payload) {
            state.showInvoice = payload;
        },
        showApplication (state, payload) {
            state.showApplication = payload;
        },
        loadApplications (state, payload) {
            state.loadApplications = payload;
        },

        setUser (state, payload) {
            state.user = payload.name;
            state.uid = payload.id;
            state.accessTeaching = payload.accessTeaching;
            state.accessAccommodation = payload.accessAccommodation;
            state.accessProjects = payload.accessProjects;
            state.accessTours = payload.accessTours;
            state.accessFinancial = payload.accessFinancial;
            state.accessCajaGrande = payload.accessCajaGrande;
            state.accessClientAgencies = payload.accessClientAgencies;
            state.showBank = payload.showBank;
            state.showWise = payload.showWise;
            state.unfreezeApplication = payload.unfreezeApplication;
            state.itemsPerPage = payload.itemsPerPage;
            state.accessMenu = Math.random();
        },

        initUsers (state, payload) {
            state.users = payload
        },
        initContacts (state, payload) {
            state.contacts = payload
        },
        initOrganisations (state, payload) {
            state.organisations = payload
        },
        initOrganisationContacts (state, payload) {
            state.organisationsContacts = payload
        },
        initProjectPlacements (state, payload) {
            state.projectPlacements = payload
        },
        initCourses (state, payload) {
            state.courses = payload
        },
        initTeachers (state, payload) {
            state.activeTeachers = payload;
            for (let index = 0; index < state.activeTeachers.length; index ++) {
                state.activeTeachers[index].visible = true;
            }
        },
        initClassRooms (state, payload) {
            state.classRooms = payload;
            for (let index = 0; index < state.classRooms.length; index ++) {
                state.classRooms[index].hide = false;
            }
        },
        statusLoggedOut (state, payload) {
            state.statusLoggedOut = payload
        },
        messagesPM (state, payload) {
            state.messagesPM = payload
        },
        resultsNotSaved (state, payload) {
            state.resultsNotSaved = payload
        },
        changeItemsPerPage (state, payload) {
            state.itemsPerPage = payload
        },
        // initLeads (state, payload) {
        //     state.leads = payload;
        // },
        initLanguageLevels (state, payload) {
            state.language_levels = payload;
        },
        initClient (state, payload) {
            (payload.start_first) ? payload.start_first = dayjs(payload.start_first).format("YYYY-MM-DD") : payload.start_first = null;
            (payload.end_last) ? payload.end_last = dayjs(payload.end_last).format("YYYY-MM-DD") : payload.end_last = null;
            (payload.spanishTestDone) ? payload.spanishTestDone = dayjs(payload.spanishTestDone).format("YYYY-MM-DD") : payload.spanishTestDone = null;
            (payload.birthdate) ? payload.birthdate = dayjs(payload.birthdate).format("YYYY-MM-DD") : payload.birthdate = null;
            (payload.pickup_date) ? payload.pickup_date = dayjs(payload.pickup_date).format("YYYY-MM-DD") : payload.pickup_date = null;
            (payload.birthdate) ? payload.birthdate = dayjs(payload.birthdate).format("YYYY-MM-DD") : payload.birthdate = null;
            (payload.welcome_email) ? payload.welcome_email = dayjs(payload.welcome_email).format("YYYY-MM-DD") : payload.welcome_email = null;
            (payload.thank_you_email) ? payload.thank_you_email = dayjs(payload.thank_you_email).format("YYYY-MM-DD") : payload.thank_you_email = null;
            (payload.first_schedule_sent) ? payload.first_schedule_sent = dayjs(payload.first_schedule_sent).format("YYYY-MM-DD") : payload.first_schedule_sent = null;
            (payload.handbookSent) ? payload.handbookSent = dayjs(payload.handbookSent).format("YYYY-MM-DD") : payload.handbookSent = null;
            (payload.nextContact) ? payload.nextContact = dayjs(payload.nextContact).format("YYYY-MM-DD") : payload.nextContact = null;
            if (payload.ignore_welcome_email === 1) {
                payload.ignore_welcome_email = true;
            } else if (payload.ignore_welcome_email === 0) {
                payload.ignore_welcome_email = false;
            }
            if (payload.ignore_thank_you_email === 1) {
                payload.ignore_thank_you_email = true;
            } else if (payload.ignore_thank_you_email === 0) {
                payload.ignore_thank_you_email = false;
            }
            if (payload.ignore_security_deposit === 1) {
                payload.ignore_security_deposit = true;
            } else if (payload.ignore_security_deposit === 0) {
                payload.ignore_security_deposit = false;
            }
            if (payload.clientPayments === 1) {
                payload.clientPayments = true;
            } else if (payload.clientPayments === 0) {
                payload.clientPayments = false;
            }
            payload.uid = state.uid;
            payload.agency = null;
            payload.pass_to_planning = false;
            // filter agency name
            if (payload.agency_id) {
                let agencyId = payload.agency_id;
                let pos = state.available_agencies.map(function(e) { return e.id; }).indexOf(agencyId);
                payload.agency = state.available_agencies[pos].name;
                if (state.available_agencies[pos].pass_to_planning === 1) {
                    payload.pass_to_planning = true;
                }
            }
            console.log('initClient', payload);
            return payload;
            // state.client = payload;
        },
        initPaymentMethods (state, payload) {
            state.paymentMethods = payload;
        },
        changeCurrentClient (state, id) {
            state.currentClient = id;
        },
        initAvailableImages (state, payload) {
            state.available_images = payload
        },
        changeStep (state, payload) {
            state.step = payload;
        },
        alertVPS (state) {
            state.alertVPS = Math.random();
        },
        alertConnection (state) {
            state.alertConnection = Math.random();
        },
        initOptions (state, payload) {
            state.options = payload;
        },
        initRadioGroups (state, payload) {
            state.radioGroups = payload
        },
        initRadioOptions (state, payload) {
            state.radioOptions = payload
        },
        setLoadingApp (state, payload) {
            state.loadingApp = payload;
        },
        showProgressBar (state, payload) {
            state.progressBar = payload
        },
        setLoadingButton (state, payload) {
            state.loadingButton = payload
        },
        errorLogIn (state, payload) {
            state.errorLogIn = payload
        },
        clearError (state) {
            state.errorLogIn = null
        },
        initNationalities (state, payload) {
            state.itemsNationality = payload
        },
        initSources (state, payload) {
            state.itemsSources = payload
            // console.log("initSources", payload)
        },
        initGeneralSettings (state, payload) {
            state.exchangeRate = payload[0].currentExchangeRate;
            state.standard_rate_individual = payload[0].standard_rate_individual;
            state.standard_rate_group = payload[0].standard_rate_group;
            state.standard_rate_special = payload[0].standard_rate_special;
            state.standard_rate_special_group = payload[0].standard_rate_special_group;
            state.financialLocked = payload[0].financial_locked;
        },
        initTypes (state, payload) {
            state.types = payload
        },
        resourceLoadedChange (state, payload) {
            state.resourceLoadedChange = payload
        },
        // initStatus (state, payload) {
        //     state.status = payload
        // },
        initProjectCategories (state, payload) {
            state.projectCategories = payload
        },
        initProjects (state, payload) {
            state.projects = payload
        },
        initDescriptions (state, payload) {
            state.available_descriptions = payload
        },
        initAvailableAgencies (state, payload) {
            console.log("initAvailableAgencies", payload)
            state.available_agencies = payload
        },
        initAvailableServices (state, payload) {
            state.available_services = payload
        },

        initResourcesPresets (state, payload) {
            state.resourcesPresets = payload
        },

        initAvailableOptions (state, payload) {
            state.availableOptions = payload
        },

        initAvailableRadioGroups (state, payload) {
            state.availableRadioGroups = payload
        },

        initAvailableRadioGroupOptions (state, payload) {
            state.availableRadioGroupOptions = payload
        },

        uploadInfos (state, payload) {
            state.uploadInfos = payload;
        },
        progressAdvance (state, payload) {
            state.progressAdvance = payload;
        },
        messageUpload (state, payload) {
            state.messageUpload = payload;
        },
        setFileName (state, payload) {
            state.fileName = payload
        },
        changeActiveTabTeaching (state, payload) {
            state.activeTabTeaching = payload;
        },
        changeActiveTabTeachers (state, payload) {
            state.activeTabTeachers = payload;
        },
        emailMessage (state, payload) {
            state.emailMessage = payload;
        },
        // sendEmail (state, payload) {
        //     state.sendEmail = payload;
        // },
        changeActiveViewClassRooms (state, payload) {
            state.activeViewClassRooms = payload;
        },
        saveDataForReport (state, payload) {
            state.dataForReport = payload;
        },
        changescopeLanguage (state, payload) {
            state.scopeLanguage = payload;
        },
        changeScopeOnline (state, payload) {
            state.scopeOnline = payload;
        },
        changeScopeResources (state, payload) {
            state.scopeResources = payload;
        },
        changeScopeTypeResources (state, payload) {
            state.scopeTypeResources = payload;
        },
        changeScopeClassGroups (state, payload) {
            state.scopeClassGroups = payload;
        },
        changeScopeClassesTeachers (state, payload) {
            state.scopeClassesTeachers = payload;
        },
        changeScopeCalendar (state, payload) {
            state.scopeCalendar = payload;
        },
        changeScopeServices (state, payload) {
            state.scopeServices = payload;
        },
        changeTeacherVisibility (state, payload) {
            state.activeTeachers[payload.index].visible = payload.visibility;
        },
        changeSelectAllTeachers (state, payload) {
            state.selectAllTeachers = payload;
        },
        successMessage (state, payload) {
            state.successMessage = payload;
            state.displaySuccessMessage = Math.random();
        },
        errorMessage (state, payload) {
            state.errorMessage = payload;
            state.displayErrorMessage = Math.random();
        },
        warningMessage (state, payload) {
            state.warningMessage = payload;
            state.displayWarningMessage = Math.random();
        },
        resourcePaymentFormSent (state, payload) {
            state.resourcePaymentFormSent = payload;
        },
        monthCalcPaymentsAccommodation (state, payload) {
            state.monthCalcPaymentsAccommodation = payload;
        },
        changeScopeApplications (state, payload) {
            state.scopeApplications = payload;
        },
        changeDirectOrAgencies (state, payload) {
            state.directOrAgencies = payload;
        },
        changeSelectedAgency (state, payload) {
            state.selectedAgency = payload;
        },
        getExchangeRates (state, payload) {
            state.exchangeRates = payload;
        },
        reloadResourcesTourAgencies (state, payload) {
            state.reloadResourcesTourAgencies = payload;
        },
        databaseName (state, payload) {
            state.databaseName = payload;
        },

        SET_ACTIVE_DASHBOARD_TYPES(state, types) {
            state.activeDashboardTypes = types;
        },

        SET_DASHBOARD_SETTINGS(state, settings) {
            state.dashboardSettings = settings;
        },

        SET_USER_PREFERENCES_DASHBOARD(state, prefs) {
            state.userPreferencesDashboard = prefs || {};
        },

        SET_SALES_SUMMARY(state, summary) {
            state.salesSummary = summary;
        },

        SET_SALES_GRAPH(state, data) {
            state.salesGraph = data;
        },

        SET_SALES_HEATMAP(state, data) {
            state.salesHeatmap = data;
        },

    },

    /********************************************************************************/
    /********************************************************************************/
    /********************************** ACTIONS *************************************/
    /********************************************************************************/
    /********************************************************************************/

    actions: {
        testConnection (context) {
            return axios
                .get(this.state.address_API + '/testConnection/')
                .then(result => {
                    console.log('testConnection', result.data, )
                    if (result.data[0].databaseName === '') {
                        context.commit('errorMessage', 'The Administration is under maintanance. Please wait and try again later.');
                        context.commit('databaseName', result.data[0].databaseName);
                    } else {
                        context.commit('successMessage', 'Connected to database: ' + result.data[0].databaseName + ' Build: ' + this.state.version);
                        context.commit('databaseName', result.data[0].databaseName);
                    }
                })
                .catch(
                    error => {
                        console.log('no network')
                        context.commit('alertConnection')
                        context.commit('statusLoggedOut', false)
                        console.log(error)
                    }
                )
        },
        setAddress_API (context, payload) {
            context.commit('address_API', payload);
        },
        signUserOut (context) {
            context.commit('statusLoggedOut', true)
        },
        resultsNotSaved (context, payload) {
            context.commit('resultsNotSaved', payload)
        },

        signUserIn (context, payload) {
            return axios
                .get(this.state.address_API + '/signUserIn/', {
                    params: {
                        name: payload.user,
                        password: payload.password
                    }
                })
                .then(result => {
                    router.push({ name: 'Illegal' });
                    if (this.state.databaseName !== '' || result.data[0].admin === 1) {
                        // console.log('USER', result.data[0]);
                        context.commit('setUser', result.data[0]);
                        context.commit('statusLoggedOut', false);
                        context.commit('setLoadingButton', false);
                        const user = result.data[0];

                        // 🔥 parse preferences safely
                        const prefs =
                          typeof user.preferencesDashboard === 'string'
                            ? JSON.parse(user.preferencesDashboard)
                            : user.preferencesDashboard || {};

                        // ✅ store DB preferences
                        context.commit('SET_USER_PREFERENCES_DASHBOARD', prefs);

                        // ✅ initialize dashboard UI state from DB
                        context.commit(
                          'SET_ACTIVE_DASHBOARD_TYPES',
                          prefs.activeTypes || [
                            'project', 'accommodation', 'spanish', 'tour'
                          ]
                        );
                    }
                })
                .catch(
                    error => {
                        context.commit('setLoadingButton', false);
                        console.log(error)
                        if (JSON.stringify(error).includes(501)) {
                            context.commit('errorLogIn', 'user and/or password incorrect')
                        } else {
                            context.commit('errorLogIn', error)
                        }
                    }
                )
        },

        changePsw (context, payload) {
            console.log(payload)
            axios.put(this.state.address_API + '/changePsw/', {
                body: payload
            })
            .then(response => {
                console.log(response);
                context.commit('setLoadingButton', false);
            })
            .catch(error => {
                console.log(error.response);
                context.commit('setLoadingButton', false);
            });
        },

        changeItemsPerPage (context, payload) {
            console.log(payload)
            axios.put(this.state.address_API + '/changeItemsPerPage/', {
                body: payload
            })
            .then(response => {
                context.commit('changeItemsPerPage', payload.itemsPerPage)
                console.log(payload.itemsPerPage, response);
                context.commit('setLoadingButton', false);
            })
            .catch(error => {
                console.log(error.response);
                context.commit('setLoadingButton', false);
            });
        },

        setLoadingApp (context, payload) {
            // console.log('setLoadingApp', payload)
            if (payload === 'add') {
                payload = this.state.loadingApp + 1;
            } else if (payload === 'dis') {
                payload = this.state.loadingApp - 1;
            }
            context.commit('setLoadingApp', payload);
        },
        showProgressBar (context, payload) {
            context.commit('showProgressBar', payload);
        },
        progressAdvance (context, payload) {
            context.commit('progressAdvance', payload);
        },
        setLoadingButton (context, payload) {
            context.commit('setLoadingButton', payload);
        },
        
        insertAvailableService (context, payload) {
            payload.uid = this.state.uid;
            return axios.post(this.state.address_API + '/insertAvailableService/', {
                body: payload
            })
            .then(response => {
                console.log(response);
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteAvaliableService(context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteAvailableService/' + payload)
            .then(result => {
                console.log(result)
                this.dispatch('getAvailableServicesEdit');
                this.dispatch('getAvailableServices');
            })
            .catch(error => {
                console.log(error);
            });
        },

        // available services VPS
        
        getAvailableServices_vps () {
            return axios
                .get(this.state.address_API + '/getAvailableServices_vps')
                .then(result => {
                    return result.data
                })
                .catch(error => {
                    console.error('getAvailableServices_vps failed:', error)
                    throw error
                })
        },
        
        deleteAllAvailableServices_vps() {
            return axios
            .delete(this.state.address_API + '/deleteAllAvailableServices_vps/')
            .then(result => {
                console.log(result)
            })
            .catch(error => {
                console.log(error);
            });
        },

        deleteAvailableService_vps (context, payload) {
            return axios
                .delete(
                    this.state.address_API +
                    '/deleteAvailableService_vps/' + payload
                )
                .then(response => {
                    return response.data
                })
                .catch(error => {
                    console.error(
                        'deleteAvailableService_vps failed:',
                        error.response || error
                    )
                    throw error
                })
        },

        upsertAvailableService_vps(context, payload) {
            return axios.post(
                this.state.address_API + '/upsertAvailableService_vps/',
                {
                    body: payload
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(
                    'upsertAvailableService_vps failed:',
                    error.response || error
                )
                throw error
            })
        },

        // available services website
        deleteAllAvailableServices_website() {
            return axios
            .delete(this.state.address_API + '/deleteAllAvailableServices_website/')
            .then(result => {
                console.log(result)
            })
            .catch(error => {
                console.log(error);
            });
        },

        insertAvailableService_website(context, payload) {
            return axios.post(this.state.address_API + '/insertAvailableService_website/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        getAvailableImages (context) {
            return axios.get(this.state.address_API + '/available_images/')
                .then(result => {
                    context.commit('initAvailableImages', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        
        async uploadImage(context, payload) {
            const uploadPayload = {
                ...payload,
                name: payload.name || this.state.fileName,
            };

            context.commit('progressAdvance', 0);

            const config = {
                onUploadProgress(progressEvent) {
                if (!progressEvent.total) return;

                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );

                context.commit('progressAdvance', percentCompleted);
                },
            };

            try {
                const response = await axios.post(
                this.state.address_API + '/upload_image/',
                uploadPayload,
                config
                );

                console.log('uploadImage response:', response.data);

                await context.dispatch('getAvailableImages');

                context.commit('successMessage', 'Image successfully uploaded!');
                return response.data;
            } catch (error) {
                console.error('uploadImage failed:', error);
                throw error;
            } finally {
                context.commit('progressAdvance', 0);
            }
        },

        deleteImage (context, payload) {
            return axios
                .delete(this.state.address_API + '/deleteImage_id/' + payload)
                .then(result => {
                    console.log(result)
                    this.dispatch('getAvailableImages', payload)
                    context.commit('successMessage', 'Image successfully removed!')
                })
                .catch(error => {
                    context.commit('errorMessage', 'Image being used!')
                    console.log(error);
                });
        },
        // **************** available images VPS *******************
        getAvailableImages_vps (context) {
            return axios.get(this.state.address_API + '/available_images_vps/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                        context.commit('errorMessage', 'something went wrong on the Package Maker, please check (available_images_vps)')
                    }
                )
        },
        uploadImage_vps (context, payload) {
            axios.post(this.state.address_API + '/upload_image_vps/', payload)
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error);
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (upload_image_vps)')
            });
        },
        deleteImage_vps (context, payload) {
            return axios
                .delete(this.state.address_API + '/deleteImage_id_vps/' + payload)
                .then(result => {
                    console.log(result)
                })
                .catch(error => {
                    console.log(error);
                    context.commit('errorMessage', 'something went wrong on the Package Maker, please check (deleteImage_id_vps)')
                });
        },
        // ***********************************************************************
        getSources (context) {
            return axios
                .get(this.state.address_API + '/sources/')
                .then(result => {
                    context.commit('initSources', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getNationalities (context) {
            return axios
                .get(this.state.address_API + '/nationalities/')
                .then(result => {
                    context.commit('initNationalities', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getGeneralSettings (context) {
            return axios
                .get(this.state.address_API + '/general_settings/')
                .then(result => {
                    context.commit('initGeneralSettings', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error);
                        return error;
                    }
                )
        },
        getUsers (context) {
            return axios
                .get(this.state.address_API + '/get_users/')
                .then(result => {
                    context.commit('initUsers', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        // Contacts

        getContacts (context) {
            return axios
                .get(this.state.address_API + '/getContacts/')
                .then(result => {
                    context.commit('initContacts', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        insertContact (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertContact/', {
                body: payload
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteContact (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteContact/' + payload)
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },

        //Organisations

        getOrganisations (context) {
            return axios
                .get(this.state.address_API + '/getOrganisations/')
                .then(result => {
                    context.commit('initOrganisations', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getOrganisationContacts (context) {
            return axios
                .get(this.state.address_API + '/getOrganisationContacts/')
                .then(result => {
                    context.commit('initOrganisationContacts', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        insertOrganisationContact (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertOrganisationContact/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteOrganisationContactsByContact (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteOrganisationContactsByContact/' + payload)
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },

        deleteOrganisationContactsByOrganisation (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteOrganisationContactsByOrganisation/' + payload)
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },

        insertOrganisation (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertOrganisation/', {
                body: payload
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteOrganisation (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteOrganisation/' + payload)
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },

        // Project Placements

        getProjectPlacements (context) {
            return axios
                .get(this.state.address_API + '/getProjectPlacements/')
                .then(result => {
                    context.commit('initProjectPlacements', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertProjectPlacement (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertProjectPlacement/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteProjectPlacement (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteProjectPlacement/' + payload)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },
        // Accommodations
        getAccommodations () {
            return axios
                .get(this.state.address_API + '/getAccommodations/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAccommodationPrices () {
            return axios
                .get(this.state.address_API + '/getAccommodationPrices/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertAccommodation (context, payload) {
            console.log('insertAccommodation', payload)
            return axios.post(this.state.address_API + '/insertAccommodation/', {
                body: payload
            })
            .then(result => {
                console.log(result);
                return result.data;
            })
            .catch(error => {
                console.log(error.result);
            });
        },
        deleteAccommodation (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteAccommodation/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },
        insertAccommodationPrices (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertAccommodationPrices/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteAccommodationPrices (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteAccommodationPrices/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },

        // Rooms
        getRooms () {
            return axios
                .get(this.state.address_API + '/getRooms/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertRoom (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertRoom/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteRoom (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteRoom/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },

        // Courses

        getAllClasses () {
            return axios
                .get(this.state.address_API + '/getAllClasses/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getCoursesTeacherId (context, teacherId) {
            return axios
                .get(this.state.address_API + '/getCoursesTeacherId/' + teacherId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getCoursesTeacherIdAll (context, teacherId) {
            return axios
                .get(this.state.address_API + '/getCoursesTeacherIdAll/' + teacherId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getCourses () {
            return axios
                .get(this.state.address_API + '/getCourses/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getCoursesAll () {
            return axios
                .get(this.state.address_API + '/getCoursesAll/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getCourseId (context, courseId) {
            console.log(courseId);
            return axios
                .get(this.state.address_API + '/getCourseId/' + courseId)
                .then(result => {
                    return result.data[0];
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertCourse (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertCourse/', {
                body: payload
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteCourse (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteCourse/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },
        // Teachers
        getAllTeachers () {
            return axios
                .get(this.state.address_API + '/getAllTeachers/')
                .then(result => {
                    this.dispatch('getTeachersActive')
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getTeachersActive (context) {
            return axios
                .get(this.state.address_API + '/getTeachersActive/')
                .then(result => {
                    context.commit('initTeachers', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertTeacher (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertTeacher/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        updateTeacherSchedule (context, payload) {
            console.log(payload);
            return axios
                .put(this.state.address_API + '/updateTeacherSchedule/', {
                    body: payload
                })
                .then(response => {
                    console.log(response);
                })
                .catch(
                    error => {
                        console.log(error);
            })
        },
        deleteTeacher (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteTeacher/' + payload)
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },
        // class rooms
        getClassRooms (context) {
            return axios
                .get(this.state.address_API + '/getClassRooms/')
                .then(result => {
                    context.commit('initClassRooms', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        // classes
        
        getClassesResourceId (context, resourceId) {
            return axios
                .get(this.state.address_API + '/getClassesResourceId/' + resourceId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesClassGroupId (context, resourceId) {
            return axios
                .get(this.state.address_API + '/getClassesClassGroupId/' + resourceId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesClientId (context, clientId) {
            return axios
                .get(this.state.address_API + '/getClassesClientId/' + clientId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClassesSafe (context, sqlTxt) {
            return axios
                .get(this.state.address_API + '/getResourcesClassesSafe/' + sqlTxt)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        deleteClassGroup (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteClassGroup/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },
        getClassesSafe (context, sqlTxt) {
            return axios
                .get(this.state.address_API + '/getClassesSafe/' + sqlTxt)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesOutgoingId (context, outgoingId) {
            return axios
                .get(this.state.address_API + '/getClassesOutgoingId/' + outgoingId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesTeacherIdOngoing (context, teacherId) {
            return axios
                .get(this.state.address_API + '/getClassesTeacherIdOngoing/' + teacherId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesTeacherIdFinishedPaid (context, teacherId) {
            return axios
                .get(this.state.address_API + '/getClassesTeacherIdFinishedPaid/' + teacherId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesTeacherIdNotPaid (context, teacherId) {
            return axios
                .get(this.state.address_API + '/getClassesTeacherIdNotPaid/' + teacherId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesTeacherIdFinishedNotPaid (context, teacherId) {
            return axios
                .get(this.state.address_API + '/getClassesTeacherIdFinishedNotPaid/' + teacherId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesTeacherIdAll (context, teacherId) {
            return axios
                .get(this.state.address_API + '/getClassesTeacherIdAll/' + teacherId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesDay (context, day) {
            return axios
                .get(this.state.address_API + '/getClassesDay/' + day)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClassesNotFinished () {
            return axios
                .get(this.state.address_API + '/getClassesNotFinished')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        async insertClass (context, payload) {
            if (payload.end < payload.start) {
                let t = payload.start;
                payload.start = payload.end;
                payload.end = t;
            }

            try {
                const result = await axios.post(
                    this.state.address_API + '/insertClass/',
                    { body: payload }
                );

                if(result.data === "error: no students") {
                    context.commit(
                        'errorMessage', 'Error: no students for these classes!'
                    );
                }

                return result?.data?.insertId ?? null;

            } catch (error) {
                console.log(error.response);
                context.commit(
                    'errorMessage',
                    'something went wrong when saving class (' + payload.class_id + '), please check'
                );

                return null;
            }
        },

        async checkAllClasses () {
            try {
                const result = await axios.post(
                    this.state.address_API + '/checkAllClasses/'
                );

                return result;

            } catch (error) {
                console.log(error.response);

                return null;
            }
        },

        async checkAllOutgoings () {
            try {
                const result = await axios.post(
                    this.state.address_API + '/checkAllOutgoings/'
                );

                return result;

            } catch (error) {
                console.log(error.response);

                return null;
            }
        },

        async checkDB () {
            try {
                const result = await axios.post(
                    this.state.address_API + '/checkDB/'
                );

                return result;

            } catch (error) {
                console.log(error.response);

                return null;
            }
        },
        
        async insertResourcesClasses (context, payload) {
            return axios.post(this.state.address_API + '/insertResourcesClasses/', {
                body: payload
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error.response);
                context.commit('errorMessage', 'something went wrong when connecting class to course (' + payload.class_id + ',' + payload.resource_id + '), please check')
            });
        },

        deleteStudentFromClassIds (context, payload) {
            return axios.delete(this.state.address_API + '/deleteStudentFromClassIds/', {
                params: { 
                    resourceId: payload.resourceId,
                    classId: payload.classId,
                }
            })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        deleteClass (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteClass/' + payload)
            .then(response => {
                console.log(response)
                return response.status;
            })
            .catch(error => {
                console.log(error);
                return 'error';
            });
        },

        // Class Groups

        insertClsGroup (context, payload) {
            // console.log('insertClassGroup ', payload);
            if (!payload.closed || payload.closed === null) {
                payload.closed = 0;
            } else {
                payload.closed = 1;
            }
            return axios.post(this.state.address_API + '/insertClassGroup/', {
                body: payload
            })
            .then(response => {
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
                context.commit('errorMessage', 'something went wrong when updating/inserting a class_goup, please check')
            });
        },

        getClassGroupsSafe (context, sqlTxt) {
            return axios
                .get(this.state.address_API + '/getClassGroupsSafe/' + sqlTxt)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        // Resources

        getResourceId (context, payload) {
            return axios
                .get(this.state.address_API + '/getResourceId/' + payload)
                .then(result => {
                    return result.data[0];
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClientId (context, payload) {
            return axios
                .get(this.state.address_API + '/getResourcesClientId/' + payload)
                .then(result => {
                    let results = result.data;
                    for (let i = 0; i < results.length; i++) {
                        (results[i].start) ? results[i].start = dayjs(results[i].start).format("YYYY-MM-DD") : results[i].start = null;
                        (results[i].end) ? results[i].end = dayjs(results[i].end).format("YYYY-MM-DD") : results[i].end = null;
                        (results[i].info_to_client) ? results[i].info_to_client = dayjs(results[i].info_to_client).format("YYYY-MM-DD") : results[i].info_to_client = null;
                        (results[i].info_to_provider) ? results[i].info_to_provider = dayjs(results[i].info_to_provider).format("YYYY-MM-DD") : results[i].info_to_provider = null;
                        (results[i].reserved) ? results[i].reserved = dayjs(results[i].reserved).format("YYYY-MM-DD") : results[i].reserved = null;
                        (results[i].family === 0) ? results[i].family = '0' : results[i].family = '1';
                        if (results[i].accommodation_class === null) {results[i].accommodation_class = 'Private Room'}
                    }
                    return results;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getAllResources () {
            return axios
                .get(this.state.address_API + '/getAllResources/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getResourcesSafe (context, resourceIds) {
            return axios
                .get(this.state.address_API + '/getResourcesSafe/' + resourceIds)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        openQuery (context, name) {
            return axios
                .get(this.state.address_API + '/openQuery/' , { params: {name} } )
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClassesIncompleted () {
            return axios
                .get(this.state.address_API + '/getResourcesClassesIncompleted/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClassesCompleted () {
            return axios
                .get(this.state.address_API + '/getResourcesClassesCompleted/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClassesNotPlanned () {
            return axios
                .get(this.state.address_API + '/getResourcesClassesNotPlanned/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClassesAlmostStarting () {
            return axios
                .get(this.state.address_API + '/getResourcesClassesAlmostStarting/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClassesExecuting () {
            return axios
                .get(this.state.address_API + '/getResourcesClassesExecuting/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesClassesAll () {
            return axios
                .get(this.state.address_API + '/getResourcesClassesAll/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesAllProjects () {
            return axios
                .get(this.state.address_API + '/getResourcesAllProjects/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesCompletedProjects () {
            return axios
                .get(this.state.address_API + '/getResourcesCompletedProjects/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesToBePaid () {
            return axios
                .get(this.state.address_API + '/getResourcesToBePaid/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesAllTours () {
            return axios
                .get(this.state.address_API + '/getResourcesAllTours/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesConfirmedNotCompletedTours () {
            return axios
                .get(this.state.address_API + '/getResourcesConfirmedNotCompletedTours/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesAccommodations () {
            return axios
                .get(this.state.address_API + '/getResourcesAccommodations/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesAllAccommodations () {
            return axios
                .get(this.state.address_API + '/getResourcesAllAccommodations/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesAccommodationsPlaced (context, payload) {
            return axios
                .get(this.state.address_API + '/getResourcesAccommodationsPlaced/', {
                    params: { 
                        start: payload.start,
                        end: payload.end,
                    }
                })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getPaymentResourceAcc (context, payload) {
            return axios
                .get(this.state.address_API + '/getPaymentResourceAcc/', {
                    params: {
                        accommodation_id: payload.accommodation_id, 
                        start: payload.start,
                        end: payload.end,
                        accommodation_class: payload.accommodation_class, 
                    }
                })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getResourcesRoomId (context, roomId) {
            return axios
                .get(this.state.address_API + '/getResourcesRoomId/' + roomId)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesReceiverContactId (context, payload) {
            return axios
            .get(this.state.address_API + '/getResourcesReceiverContactId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getResourcesReceiverOrganisationId (context, payload) {
            return axios
            .get(this.state.address_API + '/getResourcesReceiverOrganisationId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getPaymentsContactId (context, payload) {
            return axios
            .get(this.state.address_API + '/getPaymentsContactId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        updateResourceSafe (context, fields) {
            return axios
                .get(this.state.address_API + '/updateResourceSafe/' + fields)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        setOKStudentSchedule (context, payload) {
            console.log('setOKStudentSchedule', payload);
            return axios
                .put(this.state.address_API + '/setOKStudentSchedule/' + payload)
                .then(response => {
                    console.log(response);
                })
                .catch(
                    error => {
                        console.log(error);
            })
        },
        deleteResource (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteResource/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },
        getResourcesPresetsServiceNr (context, payload) {
            return axios
                .get(this.state.address_API + '/getResourcesPresetsServiceNr/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getResourcesPresets (context) {
            return axios
                .get(this.state.address_API + '/getResourcesPresets/')
                .then(result => {
                    context.commit('initResourcesPresets', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        insertResourcePreset (context, payload) {
            return axios.post(this.state.address_API + '/insertResourcePreset/', {
                body: payload
            })
            .then(response => {
                console.log('insertResourcePreset', response);
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteResourcePreset (context, payload) {
            console.log('deleteResourcePreset', payload)
            return axios
            .delete(this.state.address_API + '/deleteResourcePreset/' + payload)
            .then(response => {
                console.log('deleteResourcePreset', response);
            })
            .catch(error => {
                console.log(error);
            });
        },
        
        getTypes (context) {
            return axios
                .get(this.state.address_API + '/types/')
                .then(result => {
                    context.commit('initTypes', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getLanguageLevels (context) {
            return axios
                .get(this.state.address_API + '/getLanguageLevels/')
                .then(result => {
                    context.commit('initLanguageLevels', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        
        getProjectCategories (context) {
            return axios
                .get(this.state.address_API + '/getProjectCategories')
                .then(result => {
                    context.commit('initProjectCategories', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getProjects (context) {
            return axios
                .get(this.state.address_API + '/getProjects')
                .then(result => {
                    context.commit('initProjects', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getDonationsToBePaid () {
            return axios
                .get(this.state.address_API + '/getDonationsToBePaid')
                .then(result => {
                    console.log( result.data)
                    return result.data[0].donationsToBePaid;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getDonationsGiftedIncome () {
            return axios
                .get(this.state.address_API + '/getDonationsGiftedIncome')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getDonationsGiftedOutgoings () {
            return axios
                .get(this.state.address_API + '/getDonationsGiftedOutgoings')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getTours () {
            return axios
                .get(this.state.address_API + '/getTours')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getTourPlacements () {
            return axios
                .get(this.state.address_API + '/getTourPlacements/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertTourPlacement (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertTourPlacement/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteTourPlacement (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteTourPlacement/' + payload)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },
        
        // client agencies

        insertClientAgency (context, payload) {
            return axios.post(this.state.address_API + '/insertClientAgency/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteClientAgency (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteClientAgency/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        getAvailableDescriptions (context) {
            return axios
                .get(this.state.address_API + '/available_descriptions/')
                .then(result => {
                    context.commit('initDescriptions', result.data);
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailableAgencies (context) {
            return axios
                .get(this.state.address_API + '/available_agencies/')
                .then(result => {
                    context.commit('initAvailableAgencies', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailableServices (context) {
            return axios
                .get(this.state.address_API + '/available_services/')
                .then(result => {
                    context.commit('initAvailableServices', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailableOptions (context) {
            return axios
                .get(this.state.address_API + '/getAvailableOptions/')
                .then(result => {
                    context.commit('initAvailableOptions', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailableRadioGroups (context) {
            return axios
                .get(this.state.address_API + '/getAvailableRadioGroups/')
                .then(result => {
                    context.commit('initAvailableRadioGroups', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailableRadioGroupOptions (context) {
            return axios
                .get(this.state.address_API + '/getAvailableRadioGroupOptions/')
                .then(result => {
                    context.commit('initAvailableRadioGroupOptions', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailableServicesEdit () {
            return axios
                .get(this.state.address_API + '/getAvailableServicesEdit/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailablePriceTable (context, serviceNumber) {
            return axios
                .get(this.state.address_API + '/getAvailablePriceTable/' + serviceNumber)
                .then(result => {
                    console.log(result)
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getAvailablePriceTables () {
            return axios
            .get(this.state.address_API + '/getAvailablePriceTables')
            .then(result => {
                // context.commit('initAvailablePriceTables', result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        insertAvailablePriceTable (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertAvailablePriceTable/', {
                body: payload
            })
            .then(response => {
                console.log(response.data);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteAvailablePriceTable (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteAvailablePriceTable/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },

        getAvailablePriceTables_vps () {
            return axios
                .get(this.state.address_API + '/getAvailablePriceTables_vps')
                .then(result => {
                    return result.data
                })
                .catch(error => {
                    console.error('getAvailablePriceTables_vps failed:', error)
                    throw error
                })
        },

        deleteAllAvailablePriceTables_vps  (context) {
            return axios
            .delete(this.state.address_API + '/deleteAllAvailablePriceTables_vps/')
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (deleteAllAvailablePriceTables_vps)')
            });
        },

        deleteAvailablePriceTable_vps (context, payload) {
            return axios
                .delete(
                    this.state.address_API +
                    '/deleteAvailablePriceTable_vps/' + payload
                )
                .then(response => {
                    return response.data
                })
                .catch(error => {
                    console.error(
                        'deleteAvailablePriceTable_vps failed:',
                        error.response || error
                    )
                    throw error
                })
        },

        upsertAvailablePriceTable_vps (context, payload) {
            return axios.post(
                this.state.address_API + '/upsertAvailablePriceTable_vps',
                {
                    body: payload
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(
                    'upsertAvailablePriceTable_vps failed:',
                    error.response || error
                )
                throw error
            })
        },

        // *******************************************************************
        getAvailableOptionsServiceNr (context, payload) {
            return axios.get(this.state.address_API + '/getAvailableOptionsServiceNr/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        insertAvailableOption (context, payload) {
            return axios.post(this.state.address_API + '/insertAvailableOption/', {
                body: payload
            })
            .then(response => {
                // this.dispatch('getAvailableOptionsServiceNr')
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        
        deleteAvailableOption (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteAvailableOption/' + payload)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },
        // ***************** Available Options VPS *******************

        getAvailableOptions_vps () {
            return axios
                .get(this.state.address_API + '/getAvailableOptions_vps')
                .then(result => {
                    return result.data
                })
                .catch(error => {
                    console.error('getAvailableOptions_vps failed:', error)
                    throw error
                })
        },

        deleteAllAvailableOptions_vps (context) {
            return axios
            .delete(this.state.address_API + '/deleteAllAvailableOptions_vps/')
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (deleteAllAvailableOptions_vps)')
            });
        },

        deleteAvailableOption_vps (context, payload) {
            return axios
                .delete(
                    this.state.address_API +
                    '/deleteAvailableOption_vps/' + payload
                )
                .then(response => {
                    return response.data
                })
                .catch(error => {
                    console.error(
                        'deleteAvailableOption_vps failed:',
                        error.response || error
                    )
                    throw error
                })
        },
        
        upsertAvailableOption_vps (context, payload) {
            return axios.post(
                this.state.address_API + '/upsertAvailableOption_vps/',
                {
                    body: payload
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(
                    'upsertAvailableOption_vps failed:',
                    error.response || error
                )
                throw error
            })
        },
        
        // *******************************************************************

        insertAvailableRadioGroup (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertAvailableRadioGroup/', {
                body: payload
            })
            .then(response => {
                console.log(response);
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        
        deleteAvailableRadioGroup (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteAvailableRadioGroup/' + payload)
            .then(response => {
                console.log(response)
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },
        // ************************* Available Radio Groups ******************************************
        getAvailableRadioGroupOptionsGroupId (context, payload) {
            console.log(payload)
            return axios.get(this.state.address_API + '/getAvailableRadioGroupOptionsGroupId/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertAvailableRadioOption (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertAvailableRadioOption/', {
                body: payload
            })
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        
        deleteAvailableRadioOption (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteAvailableRadioOption/' + payload)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },

        // ***************** Available Radio Groups VPS *******************

        getAvailableRadioGroups_vps () {
            return axios
                .get(this.state.address_API + '/getAvailableRadioGroups_vps')
                .then(result => {
                    return result.data
                })
                .catch(error => {
                    console.error('getAvailableRadioGroups_vps failed:', error)
                    throw error
                })
        },

        getAvailableRadioOptions_vps () {
            return axios
                .get(this.state.address_API + '/getAvailableRadioOptions_vps')
                .then(result => {
                    return result.data
                })
                .catch(error => {
                    console.error('getAvailableRadioOptions_vps failed:', error)
                    throw error
                })
        },

        deleteAllAvailableRadioGroups_vps (context) {
            return axios
            .delete(this.state.address_API + '/deleteAllAvailableRadioGroups_vps/')
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (deleteAllAvailableRadioGroups_vps)')
                console.log(error);
            });
        },

        deleteAvailableRadioGroup_vps (context, payload) {
            return axios
                .delete(
                    this.state.address_API +
                    '/deleteAvailableRadioGroup_vps/' + payload
                )
                .then(response => {
                    return response.data
                })
                .catch(error => {
                    console.error(
                        'deleteAvailableRadioGroup_vps failed:',
                        error.response || error
                    )
                    throw error
                })
        },


        upsertAvailableRadioGroup_vps (context, payload) {
            return axios.post(
                this.state.address_API + '/upsertAvailableRadioGroup_vps/',
                {
                    body: payload
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(
                    'upsertAvailableRadioGroup_vps failed:',
                    error.response || error
                )
                throw error
            })
        },

        deleteAvailableRadioOption_vps (context, payload) {
            return axios
                .delete(
                    this.state.address_API +
                    '/deleteAvailableRadioOption_vps/' + payload
                )
                .then(response => {
                    return response.data
                })
                .catch(error => {
                    console.error(
                        'deleteAvailableRadioOption_vps failed:',
                        error.response || error
                    )
                    throw error
                })
        },

        upsertAvailableRadioOption_vps (context, payload) {
            return axios.post(
                this.state.address_API + '/upsertAvailableRadioOption_vps/',
                {
                    body: payload
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(
                    'upsertAvailableRadioOption_vps failed:',
                    error.response || error
                )
                throw error
            })
        },

        getAllInvoices () {
            return axios.get(this.state.address_API + '/getAllInvoices/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getInvoices (context, payload) {
            return axios.get(this.state.address_API + '/getInvoices/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        insertInvoice (context, payload) {
            return axios.post(this.state.address_API + '/insertInvoice/', {
                body: payload
            })
            .then(response => {
                return response.status;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        
        removeInvoice (context, payload) {
            return axios
            .delete(this.state.address_API + '/removeInvoice/' + payload)
            .then(response => {
                console.log(response)
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        },

        // **************************** synchronise client with VPS ***************************************
        getLeadPM (context, payload) {
            return axios
                .get(this.state.address_API + '/getleadPM/' + payload)
                .then(result => {
                    console.log(result)
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertLeadPM (context, payload) {
            console.log('insertLeadPM', payload);
            (payload.spanishTestDone) ? payload.spanishTestDone = dayjs(payload.spanishTestDone).format("YYYY-MM-DD HH:mm:ss") : payload.spanishTestDone = null;
            (payload.birthdate) ? payload.birthdate = dayjs(payload.birthdate).format("YYYY-MM-DD HH:mm:ss") : payload.birthdate = null;
            return axios.post(this.state.address_API + '/insertLeadPM/', {
                body: payload
            })
            .then(response => {
                // this.dispatch('getAvailableOptionsServiceNr')
                console.log(response);
                return response.status;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteLeadPM (context, payload) {
            console.log('deleteLeadPM', payload)
            return axios
            .delete(this.state.address_API + '/deleteLeadPM/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },

        async checkWithPM(context) {
            console.log("checkWithPM checking PM");

            context.commit('progressAdvance', 0);
            let progress = 1;

            try {

                const [
                    leadsRes,
                    appsRes,
                    uploadsRes,
                    emailsRes
                ] = await Promise.all([
                    axios.get(this.state.address_API + '/getLeadsPMchanged/'),
                    axios.get(this.state.address_API + '/getNewApplicationsPM/'),
                    axios.get(this.state.address_API + '/getUploadsViewPM/'),
                    axios.get(this.state.address_API + '/getClientEmails/')
                ]);

                const leads = leadsRes.data;
                const apps = appsRes.data;
                const uploads = uploadsRes.data;
                const clientsEmails = emailsRes.data;

                // Count submitted applications by email, excluding drafts
                const appsCountByEmail = new Map();

                for (const app of apps) {

                    if (String(app.statusApplication || '').toLowerCase() === 'draft') continue;

                    const email = app.email?.trim().toLowerCase();
                    if (!email) continue;

                    appsCountByEmail.set(
                        email,
                        (appsCountByEmail.get(email) || 0) + 1
                    );

                }

                // Count new uploads by lead ID
                const uploadsCountByLeadId = new Map();

                for (const upload of uploads) {
                    if (upload.lead_id == null) continue;

                    const clientId = String(upload.lead_id);

                    uploadsCountByLeadId.set(
                        clientId,
                        (uploadsCountByLeadId.get(clientId) || 0) + 1
                    );
                }

                const total = leads.length + apps.length + uploads.length;
                const step = total ? (100 - progress) / total : 0;

                const listMessagesPM = [];

                const normalizePMItem = (item) => {
                    const firstName = item.first_name || '';
                    const lastName = item.last_name || '';

                    return {
                        ...item,
                        full_name: item.full_name ||
                            `${firstName} ${lastName}`.trim(),
                        gender: item.gender || null,
                        nationality: item.nationality || null,
                    };
                };


                /* ---------------- LEADS ---------------- */

                for (const lead of leads) {

                    progress += step;
                    context.commit('progressAdvance', progress);

                    lead.status = 'changed profile';
                    lead.goClientId = lead.id;
                    lead.date = lead.updated || lead.created || null;

                    if (!lead.email) {
                        lead.status = 'no email';
                    } else {

                        let exist = clientsEmails.find(
                            c => c.email === lead.email && c.id !== lead.id
                        );

                        if (exist) {
                            lead.status = 'same email ' + exist.full_name;
                            lead.goClientId = exist.id;

                        } else {

                            exist = clientsEmails.find(c => c.email === lead.email);

                            if (!exist) {

                                const first = normalizeName(lead.first_name);
                                const last = normalizeName(lead.last_name);
                                const full_name = normalizeName(`${first} ${last}`);

                                if (full_name) {

                                    const result = await this.dispatch('searchNameClient', full_name);

                                    if (result.length > 0) {
                                        lead.goClientId = result[0].id;
                                        lead.clientToMerge = result[0].id;
                                        lead.status = 'name exists: ' + full_name;
                                    } else {
                                        lead.status = 'new lead';
                                    }
                                }
                            }
                        }
                    }

                    lead.apps =
                        appsCountByEmail.get(lead.email?.trim().toLowerCase()) || 0;

                    lead.uploads =
                        uploadsCountByLeadId.get(String(lead.id)) || 0;

                    listMessagesPM.push(normalizePMItem(lead));

                }

                /* ---------------- NEW APPLICATIONS ---------------- */

                for (const app of apps) {

                    progress += step;
                    context.commit('progressAdvance', progress);

                    const email = app.email;
                    const leadRes = await axios.get(this.state.address_API + '/getleadPM/' + email);
                    const lead = leadRes.data;

                    if (!lead) continue;

                    const existsNewLead = listMessagesPM.some(
                        m => m.email === email && m.status === 'new lead'
                    );

                    if (existsNewLead) continue;

                    const existsNewApp = listMessagesPM.some(
                        m =>
                            m.email === email &&
                            (m.status === 'new app(s)' || m.status.startsWith('name ex'))
                    );

                    if (!existsNewApp) {

                        const addApp = normalizePMItem(lead);

                        addApp.apps =
                            appsCountByEmail.get(lead.email?.trim().toLowerCase()) || 0;

                        addApp.uploads =
                            uploadsCountByLeadId.get(String(lead.id)) || 0;

                        addApp.status = 'new app(s)';
                        addApp.goClientId = lead.id;
                        addApp.date = app.created;

                        listMessagesPM.push(addApp);

                    }
                }

                /* ---------------- UPLOADS ---------------- */

                for (const upload of uploads) {

                    progress += step;
                    context.commit('progressAdvance', progress);

                    const clientId = upload.lead_id;

                    const alreadyLead = listMessagesPM.some(
                        m => m.id === clientId && m.status === 'new lead'
                    );

                    if (alreadyLead) continue;

                    const client = await this.dispatch('getClientId', clientId);

                    if (!client) continue;

                    const clientInfo = normalizePMItem(client);

                    clientInfo.apps =
                        appsCountByEmail.get(client.email?.trim().toLowerCase()) || 0;

                    clientInfo.uploads =
                        uploadsCountByLeadId.get(String(clientId)) || 0;

                    clientInfo.status = `new ${upload.type}: ${upload.name}`;
                    clientInfo.uploadId = upload.id;
                    clientInfo.goClientId = clientId;
                    clientInfo.date = upload.created;

                    listMessagesPM.push(clientInfo);

                }

                /* ---------------- DETECT NAME DIFFERENCES ---------------- */

                // Group notifications by client ID.
                const messagesByClient = new Map();

                for (const item of listMessagesPM) {
                    const clientId = item.goClientId ?? item.id;
                    if (clientId == null) continue;

                    const id = String(clientId);

                    if (!messagesByClient.has(id)) {
                        messagesByClient.set(id, []);
                    }

                    messagesByClient.get(id).push(item);
                }

                for (const [id, items] of messagesByClient) {

                    const getName = item =>
                        String(
                            item.full_name ||
                            item.full_name ||
                            `${item.first_name || ''} ${item.last_name || ''}`
                        ).trim().replace(/\s+/g, ' ');

                    const names = [
                        ...new Set(
                            items
                                .map(getName)
                                .filter(Boolean)
                                .map(name => name.toLocaleLowerCase())
                        )
                    ];

                    if (names.length > 1) {
                        const displayNames = [
                            ...new Set(items.map(getName).filter(Boolean))
                        ];

                        for (const item of items) {
                            item.nameMismatch = true;
                            item.nameDifference =
                                `Same client (ID ${id}), different names: ` +
                                displayNames.join(' / ');
                        }
                    }
                }

                /* ---------------- FINALIZE ---------------- */

                listMessagesPM.forEach((item, i) => {
                    item.index = i + 1;
                });

                context.commit('messagesPM', listMessagesPM);

            } catch (error) {

                console.log(error);
                context.commit('alertVPS');

            }

            this.dispatch('showProgressBar', false);
            context.commit('progressAdvance', 0);
        },

        
        async transferAllUploadsToCusco(context, newLead) {
            console.log('transferAllUploadsToCusco #1', newLead);

            const leadId = newLead.id;
            let uploads = [];

            try {
                // 1. Find uploads belonging to this lead
                if (!newLead.uploadId) {
                    const result = await axios.get(
                        this.state.address_API + '/getUploadsViewPM/'
                    );

                    uploads = result.data.filter(
                        item => String(item.lead_id) === String(leadId)
                    );
                } else {
                    uploads = [{
                        id: newLead.uploadId,
                        lead_id: leadId
                    }];
                }

                console.log('transferAllUploadsToCusco #2 uploads:', uploads);

                // 2. Transfer each upload
                for (const upload of uploads) {
                    console.log(
                        'transferAllUploadsToCusco #2.1 fetching upload:',
                        upload.id
                    );

                    const uploadResponse = await axios.get(
                        this.state.address_API + '/getUploadPM/' + upload.id
                    );

                    const uploadPM = uploadResponse.data?.[0];

                    if (!uploadPM) {
                        throw new Error(
                            `No upload returned for PM upload ID ${upload.id}`
                        );
                    }

                    // 3. Ensure the client ID is present
                    const clientId =
                        uploadPM.lead_id ??
                        upload.lead_id ??
                        leadId;

                    if (clientId == null) {
                        throw new Error(
                            `Cannot transfer upload ${upload.id}: client ID is missing`
                        );
                    }

                    uploadPM.client_id = clientId;
                    uploadPM.lead_id = clientId;
                    uploadPM.updated = 0;

                    // Format approved date
                    uploadPM.approved = uploadPM.approved
                        ? dayjs(uploadPM.approved).format('YYYY-MM-DD')
                        : null;

                    console.log(
                        'transferAllUploadsToCusco #2.2 prepared upload:',
                        {
                            id: uploadPM.id,
                            name: uploadPM.name,
                            client_id: uploadPM.client_id,
                            type: uploadPM.type
                        }
                    );

                    // 4. Insert/update upload in Cusco
                    await axios.post(
                        this.state.address_API + '/insertUpload/',
                        { body: uploadPM }
                    );

                    console.log(
                        'transferAllUploadsToCusco #2.3 insertUpload complete:',
                        uploadPM.id
                    );

                    // 5. Update PM upload record
                    uploadPM.updated = 0;

                    await axios.post(
                        this.state.address_API + '/insertUploadPM/',
                        { body: uploadPM }
                    );

                    console.log(
                        'transferAllUploadsToCusco #2.4 insertUploadPM complete:',
                        uploadPM.id
                    );
                }

                // 6. Refresh uploads for the client
                console.log('transferAllUploadsToCusco #3 refreshing uploads');

                await this.dispatch('getUploads', leadId);

                console.log('transferAllUploadsToCusco #4 complete');

            } catch (error) {
                console.error(
                    'transferAllUploadsToCusco failed:',
                    error.response?.status,
                    error.response?.data || error.message
                );

                throw error;
            }
        },

        async importFileToCusco (context, payload) {
            console.log('importFileToCusco', payload);
            let uploadPM = (await axios.get(this.state.address_API + '/getUploadPM/' + payload)).data[0];
            uploadPM.updated = 0;
            uploadPM.client_id = uploadPM.lead_id;
            await axios.post(this.state.address_API + '/insertUpload/', uploadPM).then(response => {
                console.log('transferUploadToCusco #2', response);
                uploadPM.updated = 0;
                axios.post(this.state.address_API + '/insertUploadPM/', {
                    body: uploadPM
                })
                context.commit('successMessage', 'File imported successfully')
            })
            .catch(error => {
                context.commit('errorMessage', 'File imported unsuccessfully')
                console.log(error.response);
            });
        },

        
        async transferUploadPM (context, uploadId) {
            const result = await axios.get(
                this.state.address_API + '/getUpload_id/' + uploadId
            );

            result.data.approved = result.data.approved
                ? dayjs(result.data.approved).format("YYYY-MM-DD HH:mm:ss")
                : null;

            return axios.post(
                this.state.address_API + '/insertUploadPM/',
                {
                    body: result.data
                }
            )
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.error(error.response || error);
                throw error;
            });
        },


        insertProject (context, payload) {
            return axios.post(this.state.address_API + '/insertProject/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteProject (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteProject/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        insertTour (context, payload) {
            return axios.post(this.state.address_API + '/insertTour/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteTour (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteTour/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        // **************************** synchronise apps with VPS ***************************************

        updateIdLeadPM_vps (context, payload) {
            return axios
            .put(this.state.address_API + '/updateIdLeadPM_vps/', {
                body: payload
            })
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },
        
        insertApplicationPM (context, payload) {
            console.log('insertApplicationPM', payload)
            return axios.post(this.state.address_API + '/insertApplicationPM/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (insertApplicationPM)')
                console.log(error.response);
            });
        },

        getApplicationsPM (context, email) {
            return axios.get(this.state.address_API + '/getApplicationsPM/' + email)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getAppsNewLeadPM (context, leadId) {
            return axios.get(this.state.address_API + '/getAppsNewLeadPM/' + leadId)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getAllApplicationsPM () {
            return axios
            .get(this.state.address_API + '/getAllApplicationsPM/')
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        
        deleteApplicationPM (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteApplicationPM/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },

        insertServicePM (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertServicePM/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (insertServicePM)')
                console.log(error.response);
            });
        },

        getServicesPM (context, clientId) {
            console.log(clientId)
            return axios.get(this.state.address_API + '/getServicesPM/' + clientId)
            .then(result => {
                console.log(result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getServicesAppIdPM (context, appId) {
            console.log(appId)
            return axios.get(this.state.address_API + '/getServicesAppIdPM/' + appId)
            .then(result => {
                console.log(result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        deleteServicePM (context, payload) {
            console.log(payload)
            return axios
            .delete(this.state.address_API + '/deleteServicePM/' + payload)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error);
            });
        },

        insertRadioGroupPM (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertRadioGroupPM/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (insertRadioGroupPM)')
                console.log(error.response);
            });
        },

        getRadioGroupsPM (context, payload) {
            console.log(payload)
            return axios.get(this.state.address_API + '/getRadioGroupsPM/' + payload)
            .then(result => {
                console.log(result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        insertOptionPM (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertOptionPM/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                context.commit('errorMessage', 'something went wrong on the Package Maker, please check (insertOptionPM)')
                console.log(error.response);
            });
        },

        getOptionsPM (context, payload) {
            console.log(payload)
            return axios.get(this.state.address_API + '/getOptionsPM/' + payload)
            .then(result => {
                console.log(result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getUploadsViewPM () {
            return axios.get(this.state.address_API + '/getUploadsViewPM/')
            .then(result => {
                console.log(result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },


        // **************************************************************************************************
        getLeads () {
            return axios.get(this.state.address_API + '/get_leads/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getClients () {
            return axios.get(this.state.address_API + '/getClients/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getDataDashboardOps (context, payload) {
            return axios.get(this.state.address_API + '/getDataDashboardOps/', {
                params: {
                start: payload.start,
                end: payload.end
                }
            }).then(res => res.data);
        },

        getPickupDashboard (context, payload) {
            return axios.get(this.state.address_API + '/getPickupDashboard/', {
                params: {
                start: payload.start,
                end: payload.end
                }
            }).then(res => res.data);
        },

        getPickups (context, payload) {
            return axios.get(this.state.address_API + '/getPickups/', {
                params: {
                start: payload.start,
                end: payload.end
                }
            }).then(res => res.data);
        },

        getProjectDropoffs(context, { weekStart, weekEnd }) {
            return axios
                .get(this.state.address_API + '/getProjectDropoffs/', {
                    params: { weekStart, weekEnd }
                })
                .then(result => {
                    return result.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateDropoffStaff (context, payload) {
            return axios.post(
                this.state.address_API + '/updateDropoffStaff',
                payload
            )
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        updateDropoffDetails (context, payload) {
            return axios.post(
                this.state.address_API + '/updateDropoffDetails',
                payload
            )
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        getEmptyClients () {
            return axios.get(this.state.address_API + '/getEmptyClients/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClientsSafe (context, sqlTxt) {
            return axios
                .get(this.state.address_API + '/getClientsSafe/' + sqlTxt)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getAllClients () {
            return axios
            .get(this.state.address_API + '/getAllClients')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getClientsCompleted () {
            return axios.get(this.state.address_API + '/getClientsCompleted/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getLeadsNoResponse () {
            return axios.get(this.state.address_API + '/getLeadsNoResponse/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getClientsIdName () {
            return axios.get(this.state.address_API + '/getClientsIdName/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        
        getClientId (context, clientId) {
            console.log('getClientId', clientId)
            return axios
                .get(this.state.address_API + '/getClientId/' + clientId)
                .then(result => {
                    
                    if (!result || !result.data || result.data.length === 0) {
                        return null; // ✅ IMPORTANT
                    }

                    let client = result.data[0];

                    if (!client) return null; // extra safety
                    
                    (client.start_first) ? client.start_first = dayjs(client.start_first).format("YYYY-MM-DD") : client.start_first = null;
                    (client.end_last) ? client.end_last = dayjs(client.end_last).format("YYYY-MM-DD") : client.end_last = null;
                    (client.spanishTestDone) ? client.spanishTestDone = dayjs(client.spanishTestDone).format("YYYY-MM-DD") : client.spanishTestDone = null;
                    (client.birthdate) ? client.birthdate = dayjs(client.birthdate).format("YYYY-MM-DD") : client.birthdate = null;
                    (client.pickup_date) ? client.pickup_date = dayjs(client.pickup_date).format("YYYY-MM-DD") : client.pickup_date = null;
                    (client.birthdate) ? client.birthdate = dayjs(client.birthdate).format("YYYY-MM-DD") : client.birthdate = null;
                    (client.welcome_email) ? client.welcome_email = dayjs(client.welcome_email).format("YYYY-MM-DD") : client.welcome_email = null;
                    (client.thank_you_email) ? client.thank_you_email = dayjs(client.thank_you_email).format("YYYY-MM-DD") : client.thank_you_email = null;
                    (client.first_schedule_sent) ? client.first_schedule_sent = dayjs(client.first_schedule_sent).format("YYYY-MM-DD") : client.first_schedule_sent = null;
                    (client.handbookSent) ? client.handbookSent = dayjs(client.handbookSent).format("YYYY-MM-DD") : client.handbookSent = null;
                    (client.firstContactLead) ? client.firstContactLead = dayjs(client.firstContactLead).format("YYYY-MM-DD") : client.firstContactLead = null;
                    (client.firstContactPPC) ? client.firstContactPPC = dayjs(client.firstContactPPC).format("YYYY-MM-DD") : client.firstContactPPC = null;
                    (client.nextContact) ? client.nextContact = dayjs(client.nextContact).format("YYYY-MM-DD") : client.nextContact = null;
                    if (client.ignore_welcome_email === 1) {
                        client.ignore_welcome_email = true;
                    } else if (client.ignore_welcome_email === 0) {
                        client.ignore_welcome_email = false;
                    }
                    if (client.ignore_thank_you_email === 1) {
                        client.ignore_thank_you_email = true;
                    } else if (client.ignore_thank_you_email === 0) {
                        client.ignore_thank_you_email = false;
                    }
                    if (client.ignore_security_deposit === 1) {
                        client.ignore_security_deposit = true;
                    } else if (client.ignore_security_deposit === 0) {
                        client.ignore_security_deposit = false;
                    }
                    if (client.clientPayments === 1) {
                        client.clientPayments = true;
                    } else if (client.clientPayments === 0) {
                        client.clientPayments = false;
                    }
                    client.uid = this.state.uid;
                    client.agency = null;
                    client.pass_to_planning = false;
                    // filter agency name
                    if (client.agency_id) {
                        let agencyId = client.agency_id;
                        let pos = this.state.available_agencies.map(function(e) { return e.id; }).indexOf(agencyId);
                        client.agency = this.state.available_agencies[pos].name;
                        if (this.state.available_agencies[pos].pass_to_planning === 1) {
                            client.pass_to_planning = true;
                        }
                    }
                    return client;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        
        deleteClient (context, clientId) {
            return axios
            .delete(this.state.address_API + '/deleteClient/' + clientId)
            .then(result => {
                console.log(result)
                this.dispatch('getLeads');
                context.commit('successMessage', 'Client successfully removed!')
            })
            .catch(error => {
                console.log(error);
            });
        },
        
        deleteService (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteService/' + payload)
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error);
            });
        },

        getPaymentMethods (context) {
            return axios.get(this.state.address_API + '/getPaymentMethods/')
                .then(result => {
                    context.commit('initPaymentMethods', result.data);
                    return 'ok';
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        changeCurrentClient (context, id) {
            context.commit('changeCurrentClient', id);
        },

        // Categories Income

        getCategoriesIncome () {
            return axios.get(this.state.address_API + '/getCategoriesIncome/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertCategoryIncome (context, payload) {
            return axios.post(this.state.address_API + '/insertCategoryIncome/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteCategoryIncome (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteCategoryIncome/' + payload)
            .then(response => {
                context.commit('successMessage', 'Category deleted');
                return response
            })
            .catch(error => {
                context.commit('errorMessage', 'Something went wrong');
                console.log(error);
            });
        },

        // Categories Outgoings

        getCategoriesOutgoings () {
            return axios.get(this.state.address_API + '/getCategoriesOutgoings/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertCategoryOutgoings (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertCategoryOutgoings/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteCategoryOutgoings (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteCategoryOutgoings/' + payload)
            .then(response => {
                context.commit('successMessage', 'Category deleted');
                return response
            })
            .catch(error => {
                context.commit('errorMessage', 'Something went wrong');
                console.log(error);
            });
        },

        // Types Income

        getTypesIncome () {
            return axios.get(this.state.address_API + '/getTypesIncome/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertTypeIncome (context, payload) {
            return axios.post(this.state.address_API + '/insertTypeIncome/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteTypeIncome (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteTypeIncome/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        // Types Outgoings

        getTypesOutgoings () {
            return axios.get(this.state.address_API + '/getTypesOutgoings/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertTypeOutgoings (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertTypeOutgoings/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteTypeOutgoings (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteTypeOutgoings/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        // Income

        getIncomeDay (context, payload) {
            return axios.get(this.state.address_API + '/getIncomeDay/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getIncomeMonth (context, payload) {
            return axios.get(this.state.address_API + '/getIncomeMonth/', {
                params: { 
                    month: payload.month,
                    year: payload.year,
                }
            })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getIncomeYear (context, payload) {
            return axios.get(this.state.address_API + '/getIncomeYear/', {
                params: { 
                    year: payload.year,
                }
            })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getAllIncomes () {
            return axios
                .get(this.state.address_API + '/getAllIncomes/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getAllOutgoings () {
            return axios
                .get(this.state.address_API + '/getAllOutgoings/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        insertIncome (context, payload) {
            return axios.post(this.state.address_API + '/insertIncome/', {
                body: payload
            })
            .then(response => {
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteIncome (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteIncome/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        // Outgoing

        getOutgoingsDay (context, payload) {
            return axios.get(this.state.address_API + '/getOutgoingsDay/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getOutgoingsMonth (context, payload) {
            return axios.get(this.state.address_API + '/getOutgoingsMonth/', {
                params: { 
                    month: payload.month,
                    year: payload.year,
                }
            })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getOutgoingsYear (context, payload) {
            return axios.get(this.state.address_API + '/getOutgoingsYear/', {
                params: { 
                    month: payload.month,
                    year: payload.year,
                }
            })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getOutgoingsApp (context, payload) {
            return axios.get(this.state.address_API + '/getOutgoingsApp/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        insertOutgoing (context, payload) {
            return axios.post(this.state.address_API + '/insertOutgoing/', {
                body: payload
            })
            .then(response => {
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        deleteOutgoing (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteOutgoing/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        // cajas

        getTotalBalancesDay (context, payload) {
            return axios.get(this.state.address_API + '/getTotalBalancesDay/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalBalancesMonth (context, payload) {
            return axios.get(this.state.address_API + '/getTotalBalancesMonth/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalDollarsBank (context, payload) {
            return axios.get(this.state.address_API + '/getTotalDollarsBank/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalSolesBank (context, payload) {
            return axios.get(this.state.address_API + '/getTotalSolesBank/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getSolesBankTable (context, payload) {
            return axios.get(this.state.address_API + '/getSolesBankTable/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getDollarsBankTable (context, payload) {
            return axios.get(this.state.address_API + '/getDollarsBankTable/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalDollarsWise (context, payload) {
            return axios.get(this.state.address_API + '/getTotalDollarsWise/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getDollarsWiseTable (context, payload) {
            return axios.get(this.state.address_API + '/getDollarsWiseTable/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalEurosWise (context, payload) {
            return axios.get(this.state.address_API + '/getTotalEurosWise/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getEurosWiseTable (context, payload) {
            return axios.get(this.state.address_API + '/getEurosWiseTable/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalGBPWise (context, payload) {
            return axios.get(this.state.address_API + '/getTotalGBPWise/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getGBPWiseTable (context, payload) {
            return axios.get(this.state.address_API + '/getGBPWiseTable/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalDollarsCajaChica (context, payload) {
            return axios.get(this.state.address_API + '/getTotalDollarsCajaChica/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalSolesCajaChica (context, payload) {
            return axios.get(this.state.address_API + '/getTotalSolesCajaChica/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalDollarsCajaFuerte (context, payload) {
            return axios.get(this.state.address_API + '/getTotalDollarsCajaFuerte/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getTotalSolesCajaFuerte (context, payload) {
            return axios.get(this.state.address_API + '/getTotalSolesCajaFuerte/' + payload)
                .then(result => {
                    console.log(result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        // Squares

        getSquaresMonth (context, payload) {
            return axios.get(this.state.address_API + '/getSquaresMonth/', {
                params: { 
                    month: payload.month,
                    year: payload.year,
                }
            })
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        getLastSquare () {
            return axios.get(this.state.address_API + '/getLastSquare/')
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        insertSquare (context, payload) {
            return axios.post(this.state.address_API + '/insertSquare/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteSquare (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteSquare/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        // Services

        getServicesClientId (context, payload) {
            return axios
            .get(this.state.address_API + '/getServicesClientId/' + payload)
            .then(result => {
                let results = result.data;
                let i;
                for (i = 0; i < results.length; i++) {
                    (results[i].start) ? results[i].start = dayjs(results[i].start).format("YYYY-MM-DD") : results[i].start = null;
                    (results[i].end) ? results[i].end = dayjs(results[i].end).format("YYYY-MM-DD") : results[i].end = null;
                }
                return results;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getServicesAppId (context, payload) {
            return axios
            .get(this.state.address_API + '/getServicesAppId/' + payload)
            .then(result => {
                console.log('getServicesAppId', result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getAllServices () {
            return axios
            .get(this.state.address_API + '/getAllServices')
            .then(result => {
                console.log('getAllServices', result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        insertExtraCharges (context, payload) {
            return axios.post(this.state.address_API + '/insertExtraCharges/', {
                body: payload
            })
            .then(response => {
                console.log(response);
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        removeExtraCharge (context, payload) {
            console.log('removeExtraCharge', payload)
            return axios
            .delete(this.state.address_API + '/removeExtraCharge/' + payload)
            .then(response => {
                return response
            })
            .catch(error => {
                console.log(error);
            });
        },

        getExtraChargesAppId (context, payload) {
            return axios
            .get(this.state.address_API + '/getExtraChargesAppId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getRadioGroupsClient (context, payload) {
            return axios
            .get(this.state.address_API + '/getRadioGroupsClient/' + payload)
            .then(result => {
                console.log(result.data)
                if (result.data.length > 0) {
                    console.log('radioGroups found', result.data);
                } else {
                    console.log('No radioGroups found', result.data);
                }
                context.commit('initRadioGroups', result.data);
                return result;
            })
            .catch(
                error => {
                    console.log('Radiogroup error', error)
                }
            )
        },
        getAllRadioGroups () {
            return axios
            .get(this.state.address_API + '/getAllRadioGroups/')
            .then(result => {
                console.log(result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log('Radiogroup error', error)
                }
            )
        },
        getAllRadioGroupsPM () {
            return axios
            .get(this.state.address_API + '/getAllRadioGroupsPM/')
            .then(result => {
                console.log(result.data);
                return result.data;
            })
            .catch(
                error => {
                    console.log('Radiogroup error', error)
                }
            )
        },
        getRadioGroupsAppId (context, payload) {
            return axios
            .get(this.state.address_API + '/getRadioGroups_appId/' + payload)
            .then(result => {
                console.log(result.data)
                if (result.data.length > 0) {
                    return result.data;
                } else {
                    console.log('No radioGroups found', result.data);
                }
                return result;
            })
            .catch(
                error => {
                    console.log('Radiogroup error', error)
                }
            )
        },
        getOptionsClient (context, payload) {
            return axios
            .get(this.state.address_API + '/getOptionsClient/' + payload)
            .then(result => {
                if (result.data.length > 0) {
                    console.log('Options found', result.data);
                } else {
                    console.log('No Options found', result.data);
                }
                context.commit('initOptions', result.data);
            })
            .catch(
                error => {
                    console.log('Options error', error)
                }
            )
        },
        getOptionsAppId (context, payload) {
            return axios
            .get(this.state.address_API + '/getOptions_appId/' + payload)
            .then(result => {
                if (result.data.length > 0) {
                    return result.data;
                } else {
                    console.log('No Options found', result.data);
                }
            })
            .catch(
                error => {
                    console.log('Options error', error)
                }
            )
        },
        getApplicationsClientId (context, payload) {
            console.log('getApplicationsClientId', payload)
            return axios
            .get(this.state.address_API + '/getApplicationsClientId/' + payload)
            .then(result => {
                console.log('getApplicationsClientId #1', result.data)
                let results = result.data;
                for (let i = 0; i < results.length; i++) {
                    (results[i].applied) ? results[i].applied = dayjs(results[i].applied).format("YYYY-MM-DD") : results[i].applied = null;
                    (results[i].syncPM == 1) ? results[i].syncPM = true : results[i].syncPM = false;
                    (results[i].frozen == 1) ? results[i].frozen = true : results[i].frozen = false;
                    (results[i].pass_to_planning == 1) ? results[i].pass_to_planning = true : results[i].pass_to_planning = false;
                    (results[i].autoAppTitle == 1) ? results[i].autoAppTitle = true : results[i].autoAppTitle = false;   
                }
                return results;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationId (context, payload) {
            console.log(payload)
            return axios
            .get(this.state.address_API + '/getApplicationId/' + payload)
            .then(result => {
                console.log(result.data);
                result = result.data[0];
                (result.applied) ? result.applied = dayjs(result.applied).format("YYYY-MM-DD") : result.applied = null;
                (result.syncPM == 1) ? result.syncPM = true : result.syncPM = false;
                (result.frozen == 1) ? result.frozen = true : result.frozen = false;
                (result.pass_to_planning == 1) ? result.pass_to_planning = true : result.pass_to_planning = false;
                (result.autoAppTitle == 1) ? result.autoAppTitle = true : result.autoAppTitle = false;   
                return result;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsNotStarted () {
            return axios
            .get(this.state.address_API + '/getApplicationsNotStarted/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getAllApplications () {
            return axios
            .get(this.state.address_API + '/getAllApplications/')
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsNotPaidDirectServices () {
            return axios
            .get(this.state.address_API + '/getApplicationsNotPaidDirectServices/')
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getApplicationsOngoingDirectServices () {
            return axios
            .get(this.state.address_API + '/getApplicationsOngoingDirectServices/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getApplicationsWaitingForClient () {
            return axios
            .get(this.state.address_API + '/getApplicationsWaitingForClient/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getApplicationsCompletedDirectServices () {
            return axios
            .get(this.state.address_API + '/getApplicationsCompletedDirectServices/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsNotPaidAgencies (context, payload) {
            return axios
            .get(this.state.address_API + '/getApplicationsNotPaidAgencies/' + payload)
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsOngoingAgencies (context, payload) {
            return axios
            .get(this.state.address_API + '/getApplicationsOngoingAgencies/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsCompletedAgencies (context, payload) {
            return axios
            .get(this.state.address_API + '/getApplicationsCompletedAgencies/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsStatusId (context, payload) {
            console.log(payload)
            return axios
            .get(this.state.address_API + '/getApplicationsStatusId/' + payload)
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsPayerAgencyId (context, payload) {
            console.log(payload)
            return axios
            .get(this.state.address_API + '/getApplicationsPayerAgencyId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getApplicationsPayerClientId (context, payload) {
            console.log(payload)
            return axios
            .get(this.state.address_API + '/getApplicationsPayerClientId/' + payload)
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        insertUpdateMainItems (context, payload) {
            // console.log("insertUpdateMainItems", payload);
            
            return axios.post(this.state.address_API + '/insertUpdateMainItems/', {
                client: payload.client,
                applications: payload.applications,
                services: payload.services,
                options: payload.options,
                radioGroups: payload.radioGroups,
                radioOptions: payload.radioOptions,
                resources: payload.resources,
            })
            .then(result => {
                if (result.status === 200) {
                    // console.log("insertUpdateMainItems #2", result.data, this.state.client, this.state.client.length);
                    // if (this.state.client && this.state.client.id !== null) {
                    //     // console.log("insertUpdateMainItems #3", result.data);
                    //     let posClientResult = result.data.clients.map(function(e) { return e.id; }).indexOf(this.state.client.id);
                    //     // console.log("insertUpdateMainItems #4", result.data.clients[posClientResult]);
                    //     if (posClientResult > -1) {
                    //         context.commit('initClient', JSON.parse(JSON.stringify(result.data.clients[posClientResult])));
                    //     }
                    // }
                    context.commit('successMessage', 'The information is successfully saved!');
                    return result;
                } else {
                    context.commit('errorMessage', 'Something went wrong with saving the information. Please check.');
                }
            })
        },

        async copyStatusBeforeCheck () {
            return await axios
                .post(this.state.address_API + '/copyStatusBeforeCheck/')
                .then(result => {
                    return result;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        
        deleteApplication (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteApplication/' + payload)
            .then(response => {
                // context.commit('successMessage', 'Application successfully removed!')
                // console.log('deleteApplication', response);
                return response;
            })
            .catch(
                error => {
                    console.log(error);
                }
            )
        },

        // Income transactions

        getOpenTransactionsIncome () {
            return axios
            .get(this.state.address_API + '/getOpenTransactionsIncome/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getAllTransactionsIncome () {
            return axios
            .get(this.state.address_API + '/getAllTransactionsIncome/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getTransactionIncomeId (context, payload) {
            return axios
            .get(this.state.address_API + '/getTransactionIncomeId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getDistributionsIncomeId (context, payload) {
            return axios
            .get(this.state.address_API + '/getDistributionsIncomeId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getDistributionsApplicationId (context, payload) {
            return axios
            .get(this.state.address_API + '/getDistributionsApplicationId/' + payload)
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getDistributionsIncomeTransactionId (context, payload) {
            return axios
            .get(this.state.address_API + '/getDistributionsIncomeTransactionId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        insertDistributionIncome (context, payload) {
            console.log(payload)
            return axios.post(this.state.address_API + '/insertDistributionIncome/', {
                body: payload
            })
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteDistributionIncomeId (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteDistributionIncomeId/' + payload)
            .then(response => {
                console.log(response);
            })
            .catch(
                error => {
                    console.log(error);
                }
            )
        },

        // Outgoings transactions

        getOpenTransactionsOutgoings () {
            return axios
            .get(this.state.address_API + '/getOpenTransactionsOutgoings/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getAllTransactionsOutgoings () {
            return axios
            .get(this.state.address_API + '/getAllTransactionsOutgoings/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        getTransactionOutgoingsId (context, payload) {
            return axios
            .get(this.state.address_API + '/getTransactionOutgoingsId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getAllOutgoingsDistributions () {
            return axios
            .get(this.state.address_API + '/getAllOutgoingsDistributions/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getDistributionsOutgoingId (context, payload) {
            return axios
            .get(this.state.address_API + '/getDistributionsOutgoingId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getDistributionsOutgoingsTransactionId (context, payload) {
            return axios
            .get(this.state.address_API + '/getDistributionsOutgoingsTransactionId/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        
        insertDistributionOutgoings (context, payload) {
            return axios.post(this.state.address_API + '/insertDistributionOutgoings/', {
                body: payload
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        executeMultipleTrees (context, payload) {
            return axios.post(this.state.address_API + '/executeMultipleTrees/', {
                body: payload
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        deleteDistributionOutgoingId (context, payload) {
            return axios
            .delete(this.state.address_API + '/deleteDistributionOutgoingId/' + payload)
            .then(response => {
                console.log(response);
            })
            .catch(
                error => {
                    console.log(error);
                }
            )
        },

        // services
        insertService (context, payload) {
            payload.last_changed_by = this.state.uid;
            return axios.post(this.state.address_API + '/insertService/', {
                body: payload
            })
            .then(response => {
                return response.data.insertId;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        async addRadioGroup (context, payload) {
            await axios.post(this.state.address_API + '/radioGroups_new/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(
                error => {
                    console.log(error);
                }
            )
        },
        async addRadioOption (context, payload) {
            return axios.post(this.state.address_API + '/radioOption_new/', {
                body: payload
            })
            .then(response => {
                console.log('addRadioOption', response.data.insertId);
                return response;
            })
            .catch(
                error => {
                    console.log(error);
                }
            )
        },
        async addRadioOptionPM (context, payload) {
            await axios.post(this.state.address_API + '/radioOption_newPM/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(
                error => {
                    console.log(error);
                }
            )
        },
        getRadioOptionsClient (context, payload) {
            return axios.get(this.state.address_API + '/getRadioOptionsClient/' + payload)
                .then(result => {
                    context.commit('initRadioOptions', result.data);
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getRadioOptionsPM (context, payload) {
            console.log(payload)
            return axios.get(this.state.address_API + '/getRadioOptionsPM/' + payload)
                .then(result => {
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        clearError (context) {
            context.commit('clearError')
        },
        setFileName (context, payload) {
            context.commit('setFileName', payload);
        },
        getUploads (context, clientId) {
            console.log("getUploads", clientId)
            return axios
                .get(this.state.address_API + '/getUploads/' + clientId)
                .then(result => {
                    context.commit('uploadInfos', result.data);
                    return result.data;
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },

        deleteUploadPM (context, payload) {
            return axios
                .delete(this.state.address_API + '/deleteUploadPM/' + payload)
                .then(result => {
                    console.log(result)
                    context.commit('successMessage', 'Upload successfully removed from PM!')
                })
                .catch(error => {
                    console.log(error);
                });
        },
        searchClient (context, payload) {
            return axios
            .get(this.state.address_API + '/searchClient/' + payload)
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        searchNameClient (context, payload) {
            return axios
            .get(this.state.address_API + '/searchNameClient/' + payload)
            .then(result => {
                console.log(result.data)
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        
        async addUpload(context, payload) {
            console.log('addUpload', payload);

            payload.name = payload.name || this.state.fileName;
            payload.approved = null;

            context.commit('progressAdvance', 0);

            const config = {
                onUploadProgress(progressEvent) {
                    if (!progressEvent.total) return;

                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );

                    context.commit('progressAdvance', percentCompleted);
                }
            };

            try {
                if (payload.type === 'accommodationDescription') {
                    const response = await axios.post(
                        this.state.address_API + '/uploadAccommodationDescription/',
                        payload,
                        config
                    );

                    context.commit(
                        'successMessage',
                        'Description successfully uploaded!'
                    );

                    context.commit('progressAdvance', 0);

                    return response;
                }

                const response = await axios.post(
                    this.state.address_API + '/insertUpload/',
                    payload,
                    config
                );

                console.log('addUpload result', response.data);

                return response.data;
            } catch (error) {
                console.error('addUpload failed:', error);
                throw error;
            } finally {
                context.commit('progressAdvance', 0);
            }
        },

        async downloadFile(context, payload) {
            console.log('downloadFile', payload);
            try {
                const result = await axios.get(
                    this.state.address_API + '/getUpload_id/' + payload
                );

                if (!result.data) return;

                const upload = result.data;

                const mimeType = upload.mime_type ||
                    (upload.name?.toLowerCase().endsWith('.pdf')
                        ? 'application/pdf'
                        : 'application/octet-stream');

                console.log("downloadFile", upload.file, mimeType)

                const blob = fileToBlob(upload.file, mimeType);

                download(blob, upload.name);
            } catch (error) {
                console.error('downloadFile failed:', error);
                throw error;
            }
        },

        
        async downloadFileAcc(context, payload) {
            try {
                console.log('downloadFileAcc', payload);

                const result = await axios.get(
                    this.state.address_API + '/getUpload_id_acc/' + payload
                );

                if (!result.data) return;

                const upload = result.data;

                const mimeType = upload.mime_type ||
                    (upload.name?.toLowerCase().endsWith('.pdf')
                        ? 'application/pdf'
                        : 'application/octet-stream');

                console.log('downloadFileAcc', upload.file, mimeType);

                // Call the standalone helper, not this.fileToBlob
                const blob = fileToBlob(upload.file, mimeType);

                download(blob, upload.name);
            } catch (error) {
                console.error('downloadFileAcc failed:', error);
                throw error;
            }
        },

        async createAttachments(context, payload) {
            try {
                const result = await axios.get(
                    this.state.address_API + '/getUpload_id/' + payload
                );

                if (!result.data) return;

                const upload = result.data;

                const mimeType = upload.mime_type ||
                    (upload.name?.toLowerCase().endsWith('.pdf')
                        ? 'application/pdf'
                        : 'application/octet-stream');

                // Preserve the previous action's Data URL return format.
                return await this.fileToDataUrl(upload.file, mimeType);
            } catch (error) {
                console.error('createAttachments failed:', error);
                throw error;
            }
        },

        fileToDataUrl(file, mimeType = 'application/octet-stream') {
            const blob = this.fileToBlob(file, mimeType);

            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => resolve(reader.result);
                reader.onerror = () => reject(reader.error);

                reader.readAsDataURL(blob);
            });
        },
        
        async getAccommodationDescription_id(context, payload) {
            try {
                console.log('getAccommodationDescription_id', payload);

                const result = await axios.get(
                    this.state.address_API +
                    '/getAccommodationDescription_id/' + payload
                );

                if (!result.data) return;

                console.log(
                    'getAccommodationDescription_id #1',
                    result.data.name
                );

                const upload = result.data;

                const mimeType = upload.mime_type ||
                    'application/octet-stream';

                const originalObj = await this.fileToDataUrl(
                    upload.file,
                    mimeType
                );

                return {
                    filename: upload.name,
                    content: originalObj
                };
            } catch (error) {
                console.error('getAccommodationDescription_id failed:', error);
                throw error;
            }
        },

        deleteFile (context, payload) {
            return axios
                .post(this.state.address_API + '/deleteUpload/', payload)
                .then(result => {
                    context.commit('successMessage', 'Document successfully removed!')
                    return result.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        deleteAccommodationDescription (context, id) {
            return axios
                .delete(this.state.address_API + '/deleteAccommodationDescription/' + id)
                .then(result => {
                    console.log(result);
                    return result;
                    // context.commit('successMessage', 'Description successfully removed!')
                })
                .catch(error => {
                    console.log(error);
                    return error;
                    // context.commit('errorMessage', 'Error removing description!')
                });
        },

        successMessage (context, payload) {
            context.commit('successMessage', payload)
        },
        errorMessage (context, payload) {
            context.commit('errorMessage', payload)
        },
        warningMessage (context, payload) {
            context.commit('warningMessage', payload)
        },
        changeActiveTabTeaching (context, payload) {
            context.commit('changeActiveTabTeaching', payload)
        },
        changeActiveTabTeachers (context, payload) {
            context.commit('changeActiveTabTeachers', payload)
        },
        scopeTypeResources (context, payload) {
            context.commit('scopeTypeResources', payload)
        },
        emailMessage (context, payload) {
            context.commit('emailMessage', payload)
        },
        changeActiveViewClassRooms (context, payload) {
            context.commit('changeActiveViewClassRooms', payload)
        },
        saveDataForReport (context, payload) {
            context.commit('saveDataForReport', payload)
        },
        changescopeLanguage (context, payload) {
            context.commit('changescopeLanguage', payload)
        },
        changeScopeOnline (context, payload) {
            context.commit('changeScopeOnline', payload)
        },
        changeScopeResources (context, payload) {
            context.commit('changeScopeResources', payload)
        },
        changeScopeClassesTeachers (context, payload) {
            context.commit('changeScopeClassesTeachers', payload)
        },
        changeScopeClassGroups (context, payload) {
            context.commit('changeScopeClassGroups', payload)
        },
        changeScopeTypeResources (context, payload) {
            context.commit('changeScopeTypeResources', payload)
        },
        changeScopeCalendar (context, payload) {
            context.commit('changeScopeCalendar', payload)
        },
        changeScopeServices (context, payload) {
            context.commit('changeScopeServices', payload)
        },
        changeTeacherVisibility (context, payload) {
            context.commit('changeTeacherVisibility', payload)
        },
        changeSelectAllTeachers (context, payload) {
            context.commit('changeSelectAllTeachers', payload)
        },
        breadcrumbs (context, payload) {
            context.commit('breadcrumbs', payload)
        },
        emailNow (context, payload) {
            return axios
                .post(this.state.address_API + '/emailNow', {
                    body: payload
                })
                .then(result => {
                    if (result.data) {
                        if (result.data === "OK") {
                            context.commit('successMessage', 'Email succesfully sent!');
                            return result.data;
                        } else {
                            context.commit('errorMessage', 'Something went wrong with sending the email!');
                            return result.data;
                        }
                    }
                })
                .catch(error => {
                    if (error.message == 'Request failed with status code 413') {
                        context.commit('errorMessage', 'Attachments are too large!');
                    } else {
                        context.commit('errorMessage', 'Something went wrong with sending the email!');
                    }
                    console.log(error);
                });
        },
        showInvoice (context, payload) {
            context.commit('showInvoice', payload)
        },
        showApplication (context, payload) {
            context.commit('showApplication', payload)
        },
        loadApplications (context, payload) {
            context.commit('loadApplications', payload)
        },
        resourcePaymentFormSent (context, payload) {
            context.commit('resourcePaymentFormSent', payload)
        },
        monthCalcPaymentsAccommodation (context, payload) {
            context.commit('monthCalcPaymentsAccommodation', payload)
        },
        changeDirectOrAgencies (context, payload) {
            context.commit('changeDirectOrAgencies', payload)
        },
        changeScopeApplications (context, payload) {
            context.commit('changeScopeApplications', payload)
        },
        changeSelectedAgency (context, payload) {
            context.commit('changeSelectedAgency', payload)
        },

        getExchangeRates (context) {
            axios.get(this.state.address_API + '/exchangeRates')
            .then(response => {
                console.log('exchangeRates:', response.data);
                context.commit('getExchangeRates', response.data);
            })
        },
        
        saveFinancialLocked (context, payload) {
            return axios.put(this.state.address_API + '/saveFinancialLocked/', {
                body: payload
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        getSecurityDeposits (context, payload) {
            return axios.get(this.state.address_API + '/getSecurityDeposits/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getSecurityDepositsTotals () {
            return axios.get(this.state.address_API + '/getSecurityDepositsTotals/')
            .then(result => {
                return result.data;
            })
            .catch(
                error => {
                    console.log(error)
                }
            )
        },

        getScheduleTeacher (context, payload) {
            return axios.get(this.state.address_API + '/getScheduleTeacher/' + payload)
            .then(result => {
                return result.data;
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        reloadResourcesTourAgencies (context, payload) {
            context.commit('reloadResourcesTourAgencies', payload)
        },

        saveWeeklyComment (context, payload) {
            return axios
                .put(this.state.address_API + '/saveWeeklyComment/', {
                    week_start: payload.week_start,
                    client_id: payload.client_id,
                    comment: payload.comment
                })
                .then(response => {
                    console.log('comment saved', response);
                    return response;
                })
                .catch(error => {
                    console.log(error.response);
                });
        },

        getWeeklyComments (context, weekStart) {
            return axios
                .get(this.state.address_API + '/getWeeklyComments', {
                    params: {
                        weekStart
                    }
                })
                .then(response => response)
                .catch(error => {
                    console.log(error.response);
                });
        },

        showCommentHistory (context, client_id) {
            return axios
                .get(this.state.address_API + '/showCommentHistory', {
                    params: {
                        client_id
                    }
                })
                .then(response => {
                    return response;
                })
                .catch(error => {
                    console.log(error.response);
                });
        },

        updatePickupStaff ({ state }, payload) {
            return axios.put(
                state.address_API + '/updatePickupStaff',
                payload
            )
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error.response);
            });
        },

        setActiveDashboardTypes({ commit }, types) {
            localStorage.setItem('dashboardTypes', JSON.stringify(types));
            commit('SET_ACTIVE_DASHBOARD_TYPES', types);
        },

        setDashboardSettings({ commit, state }, newSettings) {
            const updated = {
                ...state.dashboardSettings,
                ...newSettings
            };

            localStorage.setItem('dashboardSettings', JSON.stringify(updated));
            commit('SET_DASHBOARD_SETTINGS', updated);
        },

        async saveDashboardPreferences({ commit, state }, newPrefs) {
            const updated = {
                ...state.userPreferencesDashboard,
                ...newPrefs
            };

            commit('SET_USER_PREFERENCES_DASHBOARD', updated);

            await axios.post(state.address_API + '/user/preferences-dashboard', {
                userId: state.uid,
                preferences: updated
            });
        },

        updateClientSalesComment (context, payload) {
            return axios
                .put(this.state.address_API + '/updateClientSalesComment/', {
                    clientId: payload.clientId,
                    sales_comment: payload.sales_comment
                })
                .then(response => {
                    console.log('comment saved', response);
                    return response;
                })
                .catch(error => {
                    console.log(error.response);
                });
        },

        async fetchSalesSummary({ commit, state }, { start, end }) {
            const res = await axios.get(state.address_API + '/dashboard/sales', {
                params: { start, end }
            });

            commit('SET_SALES_SUMMARY', res.data.summary);
        },

        async fetchSalesGraph({ commit, state }, months = 6) {
            const res = await axios.get(state.address_API + '/dashboard/sales/graph', {
                params: { months }
            });

            commit('SET_SALES_GRAPH', res.data);
        },

        async fetchSalesClients(_, { start, end }) {
            return axios
                .get(this.state.address_API + '/dashboard/sales', {
                    params: { start, end }
                })
                .then(res => res.data.rows);
        },

        async fetchClientsToContact(_, { start, end }) {
            return axios
                .get(this.state.address_API + '/dashboard/sales/clientsToContact', {
                    params: { start, end }
                })
                .then(res => res.data.rows);
        },

        async fetchOpenPayments(_, { start, end }) {
            return axios
                .get(this.state.address_API + '/dashboard/sales/openPayments', {
                    params: { start, end }
                })
                .then(res => {
                    console.log('fetchOpenPayments', res.data);
                    return res.data;
                });
        },

        async fetchSalesHeatmap({ commit, state }, months = 6) {
            const res = await axios.get(state.address_API + '/dashboard/sales/heatmap', {
                params: { months }
            });

            commit('SET_SALES_HEATMAP', res.data);
        },


    },

})